import React, { useRef,useState } from "react";
import Select from "react-select";
import {Decimal} from 'decimal.js';
import moment from "moment";
// import { MDBIcon, MDBTabs, MDBTabsLink, MDBTabsContent, MDBTabsPane, MDBInput, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import CloseIcon from '@mui/icons-material/Close';
import {STATES_FAC_FACTURA} from "../Componentes/States"
import ReactToPrint from "react-to-print-advanced";
import { DateRange,Calendar  } from 'react-date-range';
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {Button} from '@mui/material';
import AddBoxIcon from "@mui/icons-material/AddBox";
import SearchIcon from "@mui/icons-material/Search";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { COLUMNS_BODEGAS,COLUMNS_LISTA_FACTURA,COLUMNS_DC_COMPRA_DETALLE,COLUMNS_LISTA_CLIENTE,COLUMNS_LISTA_ITEMS, COLUMNS_FAC_FACTURA_DETALLE_COPIA} from "../Componentes/DatatableColumns";
import { MaterialReactTable} from "material-react-table";
import ImageUploading from "react-images-uploading";
import {Label,Row,Col, Container} from "reactstrap";
// import Select from "react-dropdown-select";
import {dataDropdownTipo,dataDropdownPrint, MODULO_RESTAURANTE, get_articulo_detail, TEXT_INVOICE_ENABLED, get_list_itemsFactura_detail, imgURLServerGastos, imgURLServerGastosPreview, VERSION_1, RECIBO_NAME, RECIBO_ENABLED} from "./Services";
import {roundNumber,FOOTER_FACTURA, ITEM_DETAIL_PANEL, PANEL_VIEW_INVOICE} from "./Util";
import {DATATABLE_COLUMNS_LISTA_ORDENES,DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO,DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE,DATATABLE_COLUMNS_LISTA_CREDITOS,DATATABLE_COLUMNS_RENCUENTO,DATATABLE_COLUMNS_LISTA_COTIZACION,DATATABLE_COLUMNS_LISTA_FPAGO,DATATABLE_COLUMNS_LISTA_ANULACION,DATATABLE_DC_COMPRA_DETALLE,DATATABLE_COLUMNS_LISTA_ITEMS,DATATABLE_LISTA_CLIENTE,DATATABLE_LISTA_ITEMS,DATATABLE_COTIZACION_DETALLE, DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL, DATATABLE_COLUMNS_MOVIMIENTO, DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA} from "./Datatables"
import {STATES_COT_COTIZACION} from "./States";
import {
  Box,
  IconButton,
} from '@mui/material';
import {
  MDBBtn,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabs,
  MDBTabsPane,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
  MDBTypography,
  MDBTextArea,MDBIcon
} from "mdb-react-ui-kit";
import { imgURLocalImage } from "./Services";
import {ADD_IMAGE,SUCCES_IMAGE,SEARCH_IMAGE,EXIT_IMAGE,PRECIO_IMAGE,YAPPY_IMAGE, AWARD, REFRESH} from "./Image";
import { Componentprint_report_x, ComponentToPrintsPDFCredito } from "../Inventario/ComponentToPrintss";
const BodegaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading,
  dataCompania,
  onChangeDropdown
}) => {
  var companiaSelected="";
  var objCompania = []
    dataCompania.map((comp) => {
    objCompania.push({
      value: comp.com_id,
      label: comp.com_alias,
    });
    return comp;
  });
    dataCompania.find((data)=>{
      if(props.bod_suc === data.com_id){
        companiaSelected= data.com_alias
      }
    })
if(companiaSelected=== null){
  companiaSelected="";
}
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>BODEGAS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="bod_nombre"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="bod_nombre"
                  onChange={onChange}
                  defaultValue={props.bod_nombre}
                />
                <MDBInput
                  type="text"
                  id="bod_ubicacion"
                  wrapperClass="mb-4"
                  label="Ubicación"
                  name="bod_ubicacion"
                  onChange={onChange}
                  defaultValue={props.bod_ubicacion}
                />
                <Select
                    options={objCompania}
                    onChange={onChangeDropdown}
                    placeholder={companiaSelected.length>0 ?companiaSelected:"Sucursal"}
                    maxMenuHeight={180}
                  />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" /> Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1" />  Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ClienteModal = ({ props,isOpen,basicModalEdit,toggle,toggleSave,toggleSaveEdit,onChange,error,setFormClientesBlank,handleOnChangeCheckBox,
  loading,setFormClientes,dataRetencion}) => {
  const [anchorElRe, setAnchorElRe] = React.useState(null);
  const openRe = Boolean(anchorElRe);
  const handleClickRetencion = (event) => {
     event.preventDefault()
    setAnchorElRe(event.currentTarget);
     
  };
  const handleCloseRetencion = () => {
    setAnchorElRe(null);
  };

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop >
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{basicModalEdit?"EDITANDO CLIENTE":"NUEVO CLIENTE"}</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);setFormClientesBlank()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <Row>
                  <Col xs={12} className="input-tablet">
                    <MDBInput
                      id="cli_nombre"
                      wrapperClass="mb-3"
                      label="* Nombre"
                      name="cli_nombre"
                      onChange={onChange}
                      defaultValue={props.cli_nombre}/>
                    <MDBInput
                      id="cli_direccion"
                      wrapperClass="mb-3"
                      label="Dirección"
                      name="cli_direccion"
                      onChange={onChange}
                      defaultValue={props.cli_direccion}/>
                    <MDBInput
                      type="email"
                      id="cli_email"
                      wrapperClass="mb-3"
                      label="E-MAIL"
                      name="cli_email"
                      onChange={onChange}
                      defaultValue={props.cli_email} />
                  </Col>
                  <Col xs={6} className="input-tablet">
                    <MDBInput
                    type="text"
                    id="cli_telefono"
                    wrapperClass="mb-3"
                    label="Teléfono"
                    name="cli_telefono"
                    onChange={onChange}
                    defaultValue={props.cli_telefono}/>
                  </Col>
                  <Col xs={6} className="input-tablet">
                    <MDBInput
                    id="cli_telefono2"
                    wrapperClass="mb-3"
                    label="Teléfono 2"
                    name="cli_telefono2"
                    onChange={onChange}
                    defaultValue={props.cli_telefono2}/>
                  </Col>
                  <Col xs={6} className="input-tablet">
                      <MDBInput
                      type="text"
                      id="cli_ruc"
                      wrapperClass="mb-3"
                      label="RUC"
                      name="cli_ruc"
                      onChange={onChange}
                      defaultValue={props.cli_ruc}/>
                  </Col>
                  <Col xs={6} className="input-tablet">
                    <MDBInput
                      type="number"
                      min={1}
                      max={99}
                      id="cli_dv"
                      wrapperClass="mb-3"
                      label="DV"
                      name="cli_dv"
                      onChange={onChange}
                      defaultValue={props.cli_dv}/>
                  </Col>
                  <Col xs={6} className="mt-2 d-flex input-tablet">
                    <MDBBtn 
                      className="btn-waranty d-flex"
                      id="basic-button"
                      aria-controls={openRe ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openRe ? 'true' : undefined}
                      onClick={handleClickRetencion}
                      disabled ={false}>
                      <Row className="mx-autos">
                        <Col xs={12} className="text-center d-flex">
                        <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                        Retención
                        </Col>
                      </Row>
                      </MDBBtn>
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorElRe}
                              open={openRe}
                              onClose={handleCloseRetencion}
                              MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                "className":' css-retencion'
                              }}>
                                { dataRetencion.map((data,i)=>{
                                  return  <MenuItem key={i} onClick={()=>{handleCloseRetencion();setFormClientes({...props,re_id:data.re_id,re_desc:data.re_desc, re_porc:data.re_porc,re_codigo:data.re_codigo})}}>{data.re_desc}</MenuItem>
                                })}
                
                            </Menu>
                            <img src={EXIT_IMAGE} className="src-image-w2" alt="..." 
                      onClick={()=>      {setFormClientes({...props,re_desc:"", re_porc:"", re_codigo:"",	})}}/>
                </Col>
                <Col xs={6} className="mt-2 input-tablet">
                 <MDBInput
                    type="cli_limitc"
                    id="cli_limitc"
                    wrapperClass="mb-3"
                    label="Límite de crédito"
                    name="cli_limitc"
                    onChange={onChange}
                    defaultValue={props.cli_limitc}
                  />
                </Col>
                 {props.re_desc.length>1? <Col xs={12} className="input-tablet">
                <Label className="padd-mar-u">
                  {"Retención :" +props.re_desc}
                  </Label>
                 
                </Col>:""   }
                </Row>

              <div className="form-check form-check-inline mt-1 input-tablet">
                <input className="form-check-input" type="checkbox" name="cli_credito" id="inlineRadioPrecio"
                onChange={handleOnChangeCheckBox}  value={props.cli_credito} checked={props.cli_credito==="1"?true:false}/>
                <label className="form-check-label" htmlFor="inlineRadioPrecio">Habiliar límite de crédito</label>
              </div>
              
              </form>
            </MDBModalBody>
            <MDBModalFooter>
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                  <MDBBtn color="danger" onClick={() => {toggle(false);setFormClientesBlank()}}>
                  <MDBIcon fas icon="ban" className="me-1" />    Cerrar
                  </MDBBtn>
                  <MDBBtn   onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
                  <MDBIcon fas icon="save" className="me-1" />   Guardar
                  </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ProveedorModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>PROVEEDORES</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="prov_nombre"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="prov_nombre"
                  onChange={onChange}
                  defaultValue={props.prov_nombre}
                />
                <MDBInput
                  id="prov_direccion"
                  wrapperClass="mb-4"
                  label="Dirección"
                  name="prov_direccion"
                  onChange={onChange}
                  defaultValue={props.prov_direccion}
                />
                <MDBInput
                  type="text"
                  id="prov_telefono"
                  wrapperClass="mb-4"
                  label="Teléfono"
                  name="prov_telefono"
                  onChange={onChange}
                  defaultValue={props.prov_telefono}
                />
                <MDBInput
                  id="prov_ruc"
                  wrapperClass="mb-4"
                  label="RUC"
                  name="prov_ruc"
                  onChange={onChange}
                  defaultValue={props.prov_ruc}
                />
                <MDBInput
                  type="text"
                  id="prov_dv"
                  wrapperClass="mb-4"
                  label="DV"
                  name="prov_dv"
                  onChange={onChange}
                  defaultValue={props.prov_dv}
                />
                <MDBInput
                  type="email"
                  id="prov_email"
                  wrapperClass="mb-4"
                  label="E-MAIL"
                  name="prov_email"
                  onChange={onChange}
                  defaultValue={props.prov_email}
                />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" />   Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1" />      Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const WarningModal = ({
  props,
  isOpen,
  toggle,
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog className="modal-delete">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>AVISO</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <Label>{props.text}</Label>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" />     Salir
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const DeleteModal = ({
  props,
  isOpen,
  toggle,
  toggleDelete,
  text, error
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog className="modal-delete">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>AVISO</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
              <Label className="fw-bold">{props}</Label><br></br>
<Label>{text}</Label>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1" />     Cancelar
              </MDBBtn>
              <MDBBtn onClick={() => toggleDelete({})}>
              <MDBIcon fas icon="trash" className="me-1 " />    SI
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const GarantiaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>GARANTÍA</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="gr_name"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="gr_name"
                  onChange={onChange}
                  defaultValue={props.gr_name}
                />
                <MDBTextArea 
                  id="gr_descripcion"
                  name="gr_descripcion"
                  label="* Descripción"
                  rows={6}
                  onChange={onChange}
                  value={props.gr_descripcion}
                />
               
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="trash" className="me-1 " />  Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />     Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const DescuentoModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>DESCUENTOS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="des_number"
                  wrapperClass="mb-4"
                  label="% Descuento"
                  name="des_number"
                  onChange={onChange}
                  defaultValue={props.des_number}
                  type="number"
                />
                 <MDBInput
                  id="des_code"
                  wrapperClass="mb-4"
                  label="Nombre descuento"
                  name="des_code"
                  onChange={onChange}
                  defaultValue={props.des_code}
                    type="text"
                />
               
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="trash" className="me-1 " />  Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />     Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const GastosModal = ({
  props,
  isOpen,
  images,
  basicModalEdit,
  toggle,
  onChangeImage,
  removeImage,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading,
  objTipo,
  onChangeDropdown,
  dataTipo,
  valueSelected,
}) => {
  var objTipo = [];
  objTipo = dataTipo.map((data) => {
    return {
      value: data.tgs_id,
      label: data.tgs_desc,
    };
  });
  const maxNumber = 69;
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog
          size={window.innerWidth <= 611 ? "fullscreen" : "xl"}
          className="modal-fiscal"
        >
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>REGISTRAR GASTO</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <Row>
                  <Col xs={12}>
                    <MDBInput
                      id="gs_desc"
                      wrapperClass="mb-4"
                      label="Descripción"
                      name="gs_desc"
                      onChange={onChange}
                      defaultValue={props.gs_desc}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      id="gs_monto"
                      wrapperClass="mb-4"
                      label="* Monto"
                      name="gs_monto"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.gs_monto}
                    />
                  </Col>
                  <Col xs={6}>
                    {/* <MDBTypography variant="h6 mt-2">* Tipo</MDBTypography> */}
                    <Select
                      options={objTipo}
                      onChange={onChangeDropdown}
                      placeholder={valueSelected.length > 0 ? valueSelected : "Seleccione el gasto"}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      id="gs_fecha"
                      type="date"
                      wrapperClass="mb-2"
                      name="gs_fecha"
                      onChange={onChange}
                      defaultValue={props.gs_fecha}
                    />
                  </Col>
                  <Col xs={12}>
                    <div className="App">
                      <ImageUploading
                        multiple={false}
                        value={images}
                        onChange={onChangeImage}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                        allowNonImageType={true}
                        acceptType={["png", "jpeg", "jpg", "avif", "jfif", "webp", "avif","pdf","PDF"]}
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => 
                          (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            <Row className="mb-2">
                              <Col xs={12} className="text-center">
                                <MDBBtn
                                  type="button"
                                  style={isDragging ? { color: "red" } : undefined}
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Click or Drop here
                                </MDBBtn>
                              </Col>
                            </Row>
                            {images[0] === undefined && props.gs_imgType !=="none" && props.gs_imgType !=="" ? (
                              <Row>
                                <Col xs={12} className="text-center">
                                  {props.gs_imgType.includes("pdf")?<>
                                   <iframe src={imgURLServerGastosPreview + props.gs_imgName + props.gs_imgType} className="iframe-pdf" ></iframe>
                                  </>
                                 
                                  : <img
                                    className="img-articulos"
                                    src={imgURLServerGastosPreview + props.gs_imgName + props.gs_imgType}
                                    alt=""
                                    width="130"/>
                                    }
                                </Col>
                                <Col xs={12} className="text-center">
                                  <MDBBtn type="button" onClick={() => removeImage(props.gs_id)}>
                                    Remover
                                  </MDBBtn>
                                </Col>
                              </Row>
                            ) : null}
                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <Row>
                                  <Col xs={12} className="text-center">
                                  {image["data_url"].includes("pdf")? <embed  src={image["data_url"]} type="application/pdf"className="iframe-pdf"/>:                                    <img
                                      src={image["data_url"]}
                                      alt=""
                                      width="130"
                                      className="img-articulos"
                                    />}
                                  </Col>
                                </Row>

                                <Row className="image-item__btn-wrapper mt-2">
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageUpdate(index)}>
                                      Actualizar
                                    </MDBBtn>
                                  </Col>
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageRemove(index)}>
                                      Remover
                                    </MDBBtn>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        )}
                      </ImageUploading>
                    </div>
                  </Col>
                </Row>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
                <MDBIcon fas icon="trash" className="me-1 " /> Cerrar
              </MDBBtn>
              <MDBBtn
                onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())}
                disabled={loading}
              >
                <MDBIcon fas icon="save" className="me-1 " /> Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const MarcaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>MARCAS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="mar_descripcion"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="mar_descripcion"
                  onChange={onChange}
                  defaultValue={props.mar_descripcion}
                />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="trash" className="me-1 " />  Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />     Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const CategoriaModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  loading
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>CATEGORIAS</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="cat_descripcion"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="cat_descripcion"
                  onChange={onChange}
                  defaultValue={props.cat_descripcion}
                />
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
              <MDBIcon fas icon="ban" className="me-1 " />    Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1 " />   Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const UsuariosModal = ({
  props,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  error,
  onChangeDropdown,
  handleOnChangeCheckBox,
  loading
}) => {
    var valueSelected = "";
    var valueSelectedPrint = "";
    var objTipo =[];
    if(MODULO_RESTAURANTE){
      objTipo = dataDropdownTipo;
    }
    else{
      objTipo = dataDropdownTipo.filter((data)=>{
        if(data.objName!=="restaurante"){
          return data;
        }
         return null
      })
    }

    dataDropdownTipo.find((data,i)=>{
        if(data.value ===props.usr_perfil){
            valueSelected = data.label
            return null
        }
        return null
      }
      )
      dataDropdownPrint.find((data,i)=>{
        if(data.value ===props.usr_print){
          valueSelectedPrint = data.label
            return null
        }
         return null
      }
      )
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog  size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-full-large"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>USUARIOS</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <MDBInput
                  id="com_nombre"
                  wrapperClass="mb-4"
                  label="Sucursal"
                  name="com_nombre"
                  disabled={true}
                  onChange={onChange}
                  defaultValue={props.com_nombre+"/ Sucursal # "+props.usr_sucursal}
                />
                <MDBInput
                  id="usr_usuario"
                  wrapperClass="mb-4"
                  label="* Usuario"
                  name="usr_usuario"
                  onChange={onChange}
                  defaultValue={props.usr_usuario}
                />
                <MDBInput
                  id="usr_clave"
                  wrapperClass="mb-4"
                  label="* Clave"
                  name="usr_clave"
                  onChange={onChange}
                  defaultValue={props.usr_clave}
                />
                <MDBInput
                  id="usr_nombre"
                  wrapperClass="mb-4"
                  label="* Nombre"
                  name="usr_nombre"
                  onChange={onChange}
                  defaultValue={props.usr_nombre}/>
                  {!VERSION_1?<><MDBTypography variant="h6 mt-2">* Tipo de usuario</MDBTypography>
                    <Select
                      options={objTipo}
                      onChange={onChangeDropdown}
                      placeholder={valueSelected}
                    />
                  <MDBTypography variant="h6 mt-2">* Imprimir</MDBTypography>
                  <Select
                    options={dataDropdownPrint}
                    onChange={onChangeDropdown}
                    placeholder={valueSelectedPrint}
                  />

                  <MDBTypography variant="h6 mt-2">* Permisos</MDBTypography>
                  <div className="form-check form-check-inline mt-1">
                    <input className="form-check-input" type="checkbox" name="usr_ajustes" id="inlineRadioAjustes"
                    onChange={handleOnChangeCheckBox}  value={props.usr_ajustes} checked={props.usr_ajustes==="1"?true:false} />
                    <label className="form-check-label" htmlFor="inlineRadioAjustes">Ajustes</label>
                  </div>
                  <div className="form-check form-check-inline mt-1">
                    <input className="form-check-input" type="checkbox" name="usr_factura" id="inlineRadioFactura"
                    onChange={handleOnChangeCheckBox}  value={props.usr_factura} checked={props.usr_factura==="1"?true:false} />
                    <label className="form-check-label" htmlFor="inlineRadioFactura">Factura</label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_inventario" id="inlineInventario" value={props.usr_inventario}  
                    onChange={handleOnChangeCheckBox}  checked={props.usr_inventario==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioInventario">Inventario</label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_cotizacion" id="inlineRadioCotizacion" value={props.usr_cotizacion} 
                      onChange={handleOnChangeCheckBox} checked={props.usr_cotizacion==="1"?true:false} />
                    <label className="form-check-label" htmlFor="inlineRadioCotizacion">Cotizacion</label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_articulo" id="inlineRadioArticulos" value={props.usr_articulo} 
                     onChange={handleOnChangeCheckBox}  checked={props.usr_articulo==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioArticulo">Articulos</label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_reporte" id="inlineRadioReporte" value={props.usr_reporte} 
                     onChange={handleOnChangeCheckBox}  checked={props.usr_reporte==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioReporte">Reportes</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_apartado" id="inlineRadioReporte" value={props.usr_apartado} 
                     onChange={handleOnChangeCheckBox}  checked={props.usr_apartado==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioReporte">Apartado</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_gastos" id="inlineRadioReporte" value={props.usr_gastos} 
                     onChange={handleOnChangeCheckBox}  checked={props.usr_gastos==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioReporte">Gastos</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" name="usr_clientes" id="inlineRadioReporte" value={props.usr_clientes} 
                     onChange={handleOnChangeCheckBox}  checked={props.usr_clientes==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioReporte">Contactos</label>
                  </div>
                  <div className="form-check form-check-inline mt-1">
                    <input className="form-check-input" type="checkbox" name="usr_precio" id="inlineRadioPrecio"
                    onChange={handleOnChangeCheckBox}  value={props.usr_precio} checked={props.usr_precio==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioPrecio">Puede editar precios</label>
                  </div>
                  <div className="form-check form-check-inline mt-1">
                    <input className="form-check-input" type="checkbox" name="usr_a_costo" id="inlineRadioPrecio"
                    onChange={handleOnChangeCheckBox}  value={props.usr_a_costo} checked={props.usr_a_costo==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioPrecio">Puede ver costos de articulos</label>
                  </div></>:null}
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
                Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ArticuloModal = ({
  props,
  propsArtBodega,
  propsDropdown,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  toggleSaveEdit,
  onChange,
  onChangeDropdown,
  onChangeImage,
  images,
  error,
  onRemoveBodega,
  removeImage,
  handleOnChangeCheckBox,
  loading,
  onClickGenerateCodigo,
  usr_a_costo
}) => {
  var disabled_costo = true;
  if(basicModalEdit && usr_a_costo==="1"){
    disabled_costo = false;
  }
  if(basicModalEdit ===false){
   disabled_costo = false;
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  // const [open, SetOpen] = useState(false);
    const handleClickPrices = (event) => {
    setAnchorEl(event.currentTarget);
    // SetOpen(true)
  };
    const handleClosePrices = () => {
    setAnchorEl(null);
    // SetOpen(false)
  };

 const [isOpenDetailItem, SetOpenDetailItem] = useState(true);
   const [dataQty, setDataQty] = useState([]);
  const maxNumber = 69;
  var compraLabel = propsDropdown.itbms_compra.find((data)=>{
    if(data.value === props.art_itbm_cod_c)
      return data
    return null
  }
  )
  var ventaLabel = propsDropdown.itbms_venta.find((data)=>{
    if(data.value === props.art_itbm_cod_v)
      return data
    return null
  }
  )
    async function select_detail_articulo({art_id}) {
     var response = await get_articulo_detail(art_id);
      setDataQty(response);
  }

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-full-large"}>
          <MDBModalContent>
            <MDBModalHeader>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
              <MDBModalTitle>Articulos</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="padd-1p">
              <form>
                <Row>
                  <Col xs={12} md={8} className="input-tablet">
                    <MDBTextArea 
                      id="art_descripcion"
                      label="* Descripción"
                      name="art_descripcion"
                        wrapperClass="mb-2"
                        rows={2}
                      onChange={onChange}
                      defaultValue={props.art_descripcion}
                    />
                  </Col>
                  <Col xs={4} md={4}  className="input-tablet display-none-mobile">
                  {MODULO_RESTAURANTE?<div className="form-check form-check-inline mt-1">
                    <input className="form-check-input" type="checkbox" name="art_restaurante" id="inlineRadioAjustes"
                    onChange={handleOnChangeCheckBox}  value={props.art_restaurante} checked={props.art_restaurante==="1"?true:false}/>
                    <label className="form-check-label" htmlFor="inlineRadioAjustes">* Articulo restaurante</label>
                  </div>:null}

                  </Col>
                  <Col xs={12} md={4} className="input-tablet d-flex mb-3">
                    <MDBInput
                      id="art_upc"
                      label="* CODIGO"
                      name="art_upc"
                      maxLength={19} 
                      onChange={onChange}
                      value={props.art_upc}
                      // disabled={basicModalEdit?true:false}
                    />
 <img src={REFRESH}  onClick={()=>onClickGenerateCodigo()} className="btn-random" alt="..."/>
                  </Col>
                  <Col xs={6} md={4} className="mb-3 input-tablet">
                    <MDBInput
                      id="art_referencia"
                      label="Referencia"
                      name="art_referencia"
                      onChange={onChange}
                      defaultValue={props.art_referencia}
                    />
                  </Col>
                  <Col xs={6} md={4} className="input-tablet">
                    <MDBInput
                      id="art_serie"
                      label="Serie"
                      name="art_serie"
                      onChange={onChange}
                      defaultValue={props.art_serie}
                    />
                  </Col>
                </Row>
                <Row className="mt-2 mb-2 text-center  display-none-mobile">
                  <Col xs={6} md={4} className="input-tablet" >
                    <MDBTypography variant="h6">* Proveedor</MDBTypography>
                    <Select
                      options={propsDropdown.proveedor}
                      onChange={onChangeDropdown}
                      placeholder={props.prov_nombre}
                    />
                  </Col>
                  <Col xs={6} md={4}  className="input-tablet">
                    <MDBTypography variant="h6">* Categorias</MDBTypography>
                    <Select
                      options={propsDropdown.categorias}
                      onChange={onChangeDropdown}
                      placeholder={props.cat_descripcion}
                    />
                  </Col>
                  <Col xs={6} md={4} className="input-tablet">
                    <MDBTypography variant="h6">* Marca</MDBTypography>
                    <Select
                      options={propsDropdown.marcas}
                      onChange={onChangeDropdown}
                      placeholder={props.mar_descripcion}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} md={2} className="input-tablet mb-2"> 
                    <MDBInput
                      id="art_costo"
                      label="Costo"
                      name="art_costo"
                      wrapperClass="mb-2"
                      onChange={onChange}
                      type="number"
                      disabled={disabled_costo}
                      defaultValue={basicModalEdit && usr_a_costo==="1"?props.art_costo:""}
                    />
                  </Col>
                  {window.innerWidth<=611?<><Col xs={3} md={2} className="input-tablet mb-2 display-none-mobile">
                    <MDBInput
                      id="art_linea_roja"
                      label="Linea roja"
                      name="art_linea_roja"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_linea_roja}
                    />
                  </Col>
                  <Col xs={5} md={2}  className="d-flex input-tablet mb-2 display-none-mobile">
                    <MDBInput
                      id="inv_qty"
                      label="Cantidad"
                      name="inv_qty"
                      type="number"
                      className="h-40p"
                      onChange={onChange}
                      defaultValue={props.inv_qty}
                      disabled={true}/>
                    <Button
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={(e)=>{select_detail_articulo({art_id:props.art_id});handleClickPrices(e)}}>
                      <img alt ="" className="img-art-datatable-3" src ={SEARCH_IMAGE} />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClosePrices}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}>
                         <Col xs={12} className="modal-add-inventario datatable-factura">
                    <MaterialReactTable 
                      muiTableBodyRowProps={({row}) => ({

                        sx: {
                          backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        },
                      })} 
                      globalFilterFn="contains"
                      layoutMode="grid" 
                      renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
                      
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={false} 
                      enableTopToolbar={false}
                      enableRowActions={false}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_BODEGAS()}
                      data={ dataQty}
                    />
                    
                  </Col>
                    </Menu>
                  </Col></>:null}
                  
                  <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_precio"
                      label="* Precio 1"
                      wrapperClass="mb-2"
                      name="art_precio"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_precio}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_precio2"
                      label="Precio 2"
                      name="art_precio2"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_precio2}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_precio3"
                      label="Precio 3"
                      name="art_precio3"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_precio3}
                    />
                  </Col>
                  {window.innerWidth>=612?<> <Col xs={4} md={2} className="input-tablet">
                    <MDBInput
                      id="art_linea_roja"
                      label="Linea roja"
                      name="art_linea_roja"
                      type="number"
                      onChange={onChange}
                      defaultValue={props.art_linea_roja}
                    />
                  </Col>
                  <Col xs={4} md={2}  className="d-flex input-tablet">
                    <MDBInput
                      id="inv_qty"
                      label="Cantidad"
                      name="inv_qty"
                      type="number"
                      className="h-40p"
                      onChange={onChange}
                      defaultValue={props.inv_qty}
                      disabled={true}/>
                    <Button
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={(e)=>{select_detail_articulo({art_id:props.art_id});handleClickPrices(e)}}>
                      <img alt ="" className="img-art-datatable-3" src ={SEARCH_IMAGE} />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClosePrices}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}>
                         <Col xs={12} className="modal-add-inventario datatable-factura">
                    <MaterialReactTable 
                      muiTableBodyRowProps={({row}) => ({

                        sx: {
                          backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        },
                      })} 
                      globalFilterFn="contains"
                      layoutMode="grid" 
                      renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
                      
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={false} 
                      enableTopToolbar={false}
                      enableRowActions={false}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_BODEGAS()}
                      data={ dataQty}
                    />
                    
                  </Col>
                    </Menu>
                  </Col></>:null}
                 
                </Row>
                <Row>
                  {window.innerWidth>=612?<Col xs={2}>
                  </Col>:null}

                  <Col xs={4} md={2} className="input-tablet mt-3">
                    <MDBInput
                      id="art_utilidad"
                      label={props.art_precio==="0.00"?"Utilidad 1":"Utilidad 1 -> "+(((Number(props.art_precio) - Number(props.art_costo))/Number(props.art_costo))*100).toFixed(2)+"%"}
                      wrapperClass="mb-2"
                      name="art_utilidad"
                      type="number"
                      disabled={true}
                      value={props.art_precio1==="0.00"||""?"-":(Number(props.art_precio) - Number(props.art_costo)).toFixed(2)}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet  mt-3">
                    <MDBInput
                      id="art_utilidad2"
                      label={props.art_precio2==="0.00"?"Utilidad 2":"Utilidad 2 ->  "+(((Number(props.art_precio2) - Number(props.art_costo))/Number(props.art_costo))*100).toFixed(2)+"%"}
                      name="art_utilidad2"
                      type="number"
                      disabled={true}
                      value={props.art_precio2==="0.00"||""?"-":(Number(props.art_precio2) - Number(props.art_costo)).toFixed(2)}
                    />
                  </Col>
                  <Col xs={4} md={2} className="input-tablet  mt-3">
                    <MDBInput
                      id="art_utilidad3"
                      label={props.art_precio3==="0.00"?"Utilidad 3":"Utilidad 3 ->"+(((Number(props.art_precio3) - Number(props.art_costo))/Number(props.art_costo))*100).toFixed(2)+"%"}
                      name="art_utilidad3"
                      type="number"
                      disabled={true}
                      value={props.art_precio3==="0.00"||""?"-":(Number(props.art_precio3) - Number(props.art_costo)).toFixed(2)}
                    />
                  </Col>
                  {window.innerWidth>=612?<><Col xs={2}>
                  </Col>
                  <Col xs={2} className="d-flex">
                  </Col></>:null}
                  
                </Row>

                <Row>
                  <Col xs={6} md={4}>
                    <div className="App">
                      <ImageUploading
                        multiple={false}
                        value={images}
                        onChange={onChangeImage}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                        acceptType={['png','jpeg','jpg','avif','jfif','webp','avif']}
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            <Row className="mb-2">
                              <Col xs={12} className="text-center">
                                <MDBBtn
                                  type="button"
                                  style={isDragging ? { color: "red" } : undefined}
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Click or Drop here
                                </MDBBtn>
                              </Col>
                            </Row>
                            {images[0] === undefined && props.art_imgName.length > 0 ? (
                              <Row>
                                <Col xs={12} className="text-center">
                                  <img
                                  className="img-articulos"
                                    src={imgURLocalImage + props.art_imgName}
                                    alt=""
                                    width="130"
                                  />
                                </Col>
                                <Col xs={12} className="text-center">
                                    <MDBBtn type="button" onClick={() => removeImage(props.art_id)}>
                                      Remover
                                    </MDBBtn>
                                  </Col>
                              </Row>
                            ) : null}

                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <Row>
                                  <Col xs={12} className="text-center">
                                    <img src={image["data_url"]} alt="" width="130"  className="img-articulos"/>
                                  </Col>
                                </Row>

                                <Row className="image-item__btn-wrapper mt-2">
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageUpdate(index)}>
                                      Actualizar
                                    </MDBBtn>
                                  </Col>
                                  <Col xs={6} className="text-center">
                                    <MDBBtn type="button" onClick={() => onImageRemove(index)}>
                                      Remover
                                    </MDBBtn>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        )}
                      </ImageUploading>
                    </div>
                  </Col>
                  <Col xs={4} className="display-none-mobile">
                  <MDBTypography variant="h6">* Compra</MDBTypography>
                  <Select
                      options={propsDropdown.itbms_compra}
                      onChange={onChangeDropdown}
                      placeholder={compraLabel=== undefined?"":compraLabel.label}
                      maxMenuHeight={150}
                    />
                    {/* <MDBInput
                      id="art_itbm_venta"
                      wrapperClass="mb-4"
                      label="ITBM Venta"
                      name="art_itbm_venta"
                      type="number"
                      onChange={onChange}
                      value={props.art_itbm_venta}
                    /> */}
                  </Col>
                  <Col xs={6} md={4}>
                  <MDBTypography variant="h6">* Venta</MDBTypography>
                  <Select
                      options={propsDropdown.itbms_venta}
                      onChange={onChangeDropdown}
                      placeholder={ventaLabel=== undefined?"":ventaLabel.label}
                      maxMenuHeight={150}
                    />
                
                    {/* <MDBInput
                      id="art_itbm_compra"
                      wrapperClass="mb-4"
                      type="number"
                      label="ITBM Compra"
                      name="art_itbm_compra"
                      onChange={onChange}
                      value={props.art_itbm_compra}
                    /> */}
                  </Col>
                </Row>
              </form>
            </MDBModalBody>
            <MDBModalFooter className="margin-padding-u">
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
                Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (basicModalEdit ? toggleSaveEdit() : toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const PublicidadModal = ({
  toggle,
  props,
  isOpen,
  onChangeImage,
  images,
  onImageUpload,
  removeImage,
  onImageUpdate,
  onImageRemove,
  toggleSave,
  error,
  loading
}) => {
  const maxNumber = 69;
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Publicidad</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
            <div className="App">
            <ImageUploading
              multiple={false}
              value={images}
              onChange={onChangeImage}
              maxNumber={maxNumber}
              dataURLKey="data_url"
              acceptType={['png','jpeg','jpg','avif','jfif','webp','avif']}>
              {({imageList,onImageUpload,onImageRemoveAll,onImageUpdate,onImageRemove,isDragging,dragProps}) => (
                // write your building UI
                <div className="upload__image-wrapper">
                  <Row className="mb-2">
                    <Col xs={12} className="text-center">
                      <MDBBtn
                        type="button"
                        style={isDragging ? { color: "red" } : undefined}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        Click or Drop here
                      </MDBBtn>
                    </Col>
                  </Row>
                  {images[0] === undefined && props.img_name.length > 0 ? (
                    <Row>
                      <Col xs={12} className="text-center">
                        <img
                        
                          src={imgURLocalImage + props.img_name}
                          alt=""
                          width="130"
                        />
                      </Col>
                      <Col xs={12} className="text-center">
                          <MDBBtn type="button" onClick={() => removeImage(props.img_id )}>
                            Remover
                          </MDBBtn>
                        </Col>
                    </Row>
                  ) : null}

                  {imageList.map((image, index) => (
                    <div key={index} className="image-item">
                      <Row>
                        <Col xs={12} className="text-center">
                          <img className="img-p-preview" src={image["data_url"]} alt="" width="130" />
                        </Col>
                      </Row>

                      <Row className="image-item__btn-wrapper mt-2">
                        <Col xs={6} className="text-center">
                          <MDBBtn type="button" onClick={() => onImageUpdate(index)}>
                            Actualizar
                          </MDBBtn>
                        </Col>
                        <Col xs={6} className="text-center">
                          <MDBBtn type="button" onClick={() => onImageRemove(index)}>
                            Remover
                          </MDBBtn>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              )}
            </ImageUploading>
          </div>
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => toggle(false)}>
                Cerrar
              </MDBBtn>
              <MDBBtn onClick={() => (toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const FacturaCompraModal = ({
  dataBodegas,
  props,
  dataCompraDetalle,
  propsDCDetail,
  formDropdown,
  propsDropdown,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  onChange,
  onChangeDC_detail,
  handleKeyPress,
  onChangeDropdown,
  onBlurs,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJCompraDetalle,
  fetchDCCompra,
  update_dcd_compra_detalle_row,
  toggleSaveEncabezado,
  dataItems,
  selectItem,
  setFormCompraDetalle,
  loading,
  usr_sucursal,
  usr_a_costo
}) => {
  const [isTabItems, setTabItems] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  var bodegas =dataBodegas.filter((data,i)=>{
    if(usr_sucursal ===data.bod_suc)
    return data
  });
  var enableTab = true
  if(props.dc_docn.length>0 && props.dc_fecha.length>0 && formDropdown.prov_id.length>0 && formDropdown.bod_id.length>0){
    enableTab = false
  }
  const ref = useRef(null);
  var subtotal=0;
  var itbms =0;
  var total = 0;
  var existencia =0;
  const [formDetailItem, setFormDetailItem] = useState({
    art_categoria : "",
    art_descripcion : "",
    art_id : "",
    art_img : null,
    art_imgName : "",
    art_itbm_cod_v: "",
    art_itbm_venta: "",
    art_precio: "",
    art_precio2: "",
    art_precio3: "",
    art_referencia: "",
    art_restaurante: "",
    art_upc: "",
    cat_descripcion: "",
    itbm_descripcion: "",
    mar_descripcion: "",
  });
async function select_detail_articulo({row}) {   
    var response = await get_articulo_detail(row.art_id);
    setFormDetailItem({
    art_categoria : row.art_categoria,
    art_descripcion : row.art_descripcion,
    art_id : row.art_id,
    art_img : row.art_img,
    art_imgName :row.art_imgName,
    art_itbm_cod_v:row.art_itbm_cod_v,
    art_itbm_venta: row.art_itbm_venta,
    art_precio: row.art_precio,
    art_precio2: row.art_precio2,
    art_precio3: row.art_precio3,
    art_referencia: row.art_referencia,
    art_restaurante: row.art_restaurante,
    art_upc: row.art_upc,
    cat_descripcion: row.cat_descripcion,
    itbm_descripcion: row.itbm_descripcion,
    mar_descripcion: row.mar_descripcion,
    bodegas:response});
    SetOpenDetailItem(true)
}
  if(isOpenDetailItem && formDetailItem.bodegas !== undefined){
    formDetailItem.bodegas.map((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })}
dataCompraDetalle.map((row,i)=>{
  subtotal = Number(subtotal) + Number((Number(row.dcd_cantidad)*Number(row.dcd_precio)));
  itbms = Number(itbms) + Number(row.dcd_itbms);
  total = Number(subtotal)+Number(itbms);
 return null
})

const handleSaveRow = ({
  exitEditingMode,
  row,
  values
}) => {

if(basicModalEdit){
  update_dcd_compra_detalle_row({
    dcd_cantidad:values.dcd_cantidad,
    dcd_id:row.original.dcd_id, 
    dcd_itbms:((new Decimal(values.dcd_cantidad).times(new Decimal(row.original.dcd_precio)))).times(new Decimal(row.original.art_itbm_compra)).toDecimalPlaces(2,Decimal.ROUND_UP),
    dcd_total: ((new Decimal(values.dcd_cantidad).times(row.original.dcd_precio)).times(new Decimal(1).plus(row.original.art_itbm_compra))).toDecimalPlaces(2,Decimal.ROUND_UP),
  },row.original.dcd_identificador)
  exitEditingMode();
}
else{
  dataCompraDetalle[row.index] = {
      art_upc:row.original.art_upc,
      art_descripcion: row.original.art_descripcion,
      art_itbm_cod_c:row.original.art_itbm_cod_c,
      art_itbm_compra:row.original.art_itbm_compra,
      dcd_articulo:row.original.dcd_articulo,
      dcd_cantidad: values.dcd_cantidad,
      dcd_descuento:row.original.dcd_descuento,
      dcd_descuento_number:row.original.dcd_descuento_number,
      dcd_id:row.original.dcd_id,
      dcd_itbms: ((new Decimal(values.dcd_cantidad).times(new Decimal(row.original.dcd_precio)))).times(new Decimal(row.original.art_itbm_compra)).toDecimalPlaces(2,Decimal.ROUND_UP),
      dcd_precio: values.dcd_precio,
      dcd_total: ((new Decimal(values.dcd_cantidad).times(row.original.dcd_precio)).times(new Decimal(1).plus(row.original.art_itbm_compra))).toDecimalPlaces(2,Decimal.ROUND_UP),
    };

    setOBJCompraDetalle([...dataCompraDetalle]);
    exitEditingMode();
}
};

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="fullscreen" className="modal-full-large">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>FACTURA DE COMPRA</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchDCCompra()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
                <>
                {isTabItems?<>
                 {isOpenDetailItem?<> {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}</>:
<Row>
<Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
              {dataItems !==undefined?<DATATABLE_LISTA_ITEMS select_detail_articulo={select_detail_articulo} dataItems={dataItems} selectItem={selectItem} setTabItems={setTabItems} usr_a_costo={usr_a_costo}/>:<Label>Cargando...</Label>}
                  </Col>
</Row>}
                </>:<>
                <form>
                <Row>
                  <Col xs={2}>
                    <MDBInput
                      id="dc_docn"
                      wrapperClass="mb-3"
                      label="* N° Documento"
                      name="dc_docn"
                      onChange={onChange}
                      defaultValue={props.dc_docn}
                    />
                  </Col>
                  <Col xs={2}>
                    <MDBInput
                      id="dc_fecha"
                      type="date"
                      wrapperClass="mb-3"
                      label="* Fecha documento"
                      name="dc_fecha"
                      onChange={onChange}
                      defaultValue={props.dc_fecha}
                    />
                  </Col>
                  <Col xs={4}>
                    <Select
                      options={propsDropdown}
                      onChange={onChangeDropdown}
                      placeholder={formDropdown.prov_nombre.length===0?"Proveedores":"Proveedor: "+formDropdown.prov_nombre}
                      maxMenuHeight={150}
                    />
                  </Col>
                  <Col xs={4}>
                    <Select
                      options={bodegas}
                      onChange={onChangeDropdown}
                      placeholder={formDropdown.bod_nombre.length===0?"Bodega":"Bodega: "+formDropdown.bod_nombre}
                      maxMenuHeight={150}
                    />
                  </Col>
                  <Col xs={12}>
                    <MDBInput
                      id="dc_descripcion"
                      wrapperClass="mb-1"
                      label="Descripción"
                      name="dc_descripcion"
                      onChange={onChange}
                      defaultValue={props.dc_descripcion}
                      
                    />
                  </Col>
                </Row>
              </form>
              <Row >
              <Col xs={12}>
                    <Label className="error-label-inventario">
                      - {error_upc}
                    </Label>
                  </Col>
                  <Col xs ={12} className="mt-2">
                    <Row>
                    <Col xs={3} className="d-flex">
                  <MDBInput
                      id="art_upc"
                      wrapperClass="mb-2"
                      label="Código o referencia"
                      name="art_upc"
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_upc}
                      disabled={enableTab}
                      onKeyDown={(e) =>{
                        handleKeyPress(e, props.dcd_articulo);
                      }
                      }
                    />
                      {enableTab===true?null:<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true)}}/>}
                      {enableTab===false && propsDCDetail.art_upc.length>0?<img src={EXIT_IMAGE} className="src-image" alt="..." onClick={()=>{     
                         setFormCompraDetalle({
                          dcd_id: "",
                          dcd_articulo: "",
                          dcd_precio: "",
                          dcd_cantidad: "1",
                          dcd_itbms: "",
                          dcd_descuento: "",
                          dcd_total: "",
                          dcd_descuento_number: "",
                          art_descripcion: "",
                          art_upc:""
                        });
                      
                      }}/>:null}
                  </Col>
                  <Col xs={5}>
                  <MDBInput
                      id="art_descripcion"
                      wrapperClass="mb-2"
                      label="Descripción del artículo"
                      name="art_descripcion"
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_descripcion}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                      id="dcd_precio"
                      wrapperClass="mb-2"
                      label="Costo"
                      name="dcd_precio"
                      // autoFocus ={true}
                      type={"number"}
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.dcd_precio}
                      disabled= {propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2} className="d-flex">
                  <MDBInput
                      id="dcd_cantidad"
                      wrapperClass="mb-2"
                      label="Cantidad"
                      name="dcd_cantidad"
                      autoFocus ={true}
                      type={"number"}
                      min={"1"}
                      ref={ref}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                      onChange={onChangeDC_detail}
                      value={propsDCDetail.art_descripcion.length>0?propsDCDetail.dcd_cantidad:""}
                      onKeyDown={(e) =>
                        handleKeyPress(e, propsDCDetail.dcd_cantidad,"")
                      }
                    />
                    {propsDCDetail.art_upc.length>0 ?<img src={ADD_IMAGE}  namebtn="dcd_cantidad" className="src-image-2" alt="..." onClick={(e)=>{handleKeyPress(e, propsDCDetail.dcd_cantidad,"btn");}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                  </Col>
                <Col className="modal-add-inventario datatable-factura css_datatable1">
                <DATATABLE_DC_COMPRA_DETALLE deleteRow ={deleteRow} onBlurs={onBlurs} enableTab={enableTab} handleSaveRow={handleSaveRow} dataCompraDetalle={dataCompraDetalle} />
                </Col>


              </Row>
              <Row className="mt-3">
                  <Col xs={6}>
                  </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_subtotal"
                      wrapperClass="mb-2"
                      label="SUBTOTAL"
                      name="dcd_i_subtotal"
                      autoFocus ={true}
                      value={
                        enableTab?[]:subtotal.toFixed(2)
                      }
                      disabled={true}
                    />
                </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_itbms"
                      wrapperClass="mb-2"
                      label="ITBMS"
                      name="dcd_i_itbms"
                      autoFocus ={true}
                      value={
                        enableTab?[]:itbms.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                  className="input-iventario-totales"
                      id="dcd_i_total"
                      wrapperClass="mb-2"
                      label="TOTAL"
                      name="dcd_i_total"
                      autoFocus ={true}
                      value={                 enableTab?[]:total.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                    </Row>
                  </Col>
                </Row>       
                </>}   
                </>
            </MDBModalBody>
            <MDBModalFooter>
            {isTabItems?<>
              <Row>
                <Col xs={12} className="text-center">
                <MDBBtn color="danger" onClick={() => {setTabItems(false)}}>
                <MDBIcon fas icon="ban" className="me-1"  />   Cerrar
              </MDBBtn>
                </Col>
              </Row>
            </>:<>
            <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchDCCompra();}}>
              <MDBIcon fas icon="ban" className="me-1"  />    Cerrar
              </MDBBtn>
              {basicModalEdit?<MDBBtn  onClick={() => ( toggleSaveEncabezado())}>
                  Guardar
                </MDBBtn>:              <MDBBtn onClick={() => ( toggleSave())} disabled={loading}>
              <MDBIcon fas icon="save" className="me-1"  />  Guardar
              </MDBBtn>}

            </>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const MovimientoModal = ({
  props,
  setFormMovimiento,
  dataMovimientoDetalle,
  formMovimientoDetalle,
  isOpen,
  basicModalEditMov,
  toggle,
  toggleSave,
  onChange,
  onChangeRed_detail,
  handleKeyPress,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJMovimientoDetalle,
  fetchMovimiento,
  dataItems,
  update_mov_movimiento_detalle_row,
  toggleSaveEncabezado,
  dataRecuento,
  selectItem,
  setFormMovimientoDetalle,
  loading,
  dataBodegas,
  onChangeDropdown,usr_a_costo
}) => {

  var ObjBodegaDesde = [];
  var ObjBodegaHacia = [];
  var dataItemsFilter;
  dataItemsFilter = dataItems.filter((data,i)=>{
    if(data.bod_id==props.mov_bodega_desde){
      return data;
    }
  })
  const [isTabItems, setTabItems] = useState(false);
  var enableTab = true
  if(props.mov_fecha.length>0 && props.mov_bodega_desde.length>0 && props.mov_bodega_hacia.length>0){
    enableTab = false
  }
  dataBodegas.map((bodega) => {
    ObjBodegaDesde.push({
      value: bodega.bod_id,
      label: bodega.bod_nombre,
      objName: "bodegaDesde",
    });
    return bodega;
  });
    dataBodegas.map((bodega) => {
      if(props.mov_bodega_desde!==bodega.bod_id){
        ObjBodegaHacia.push({
          value: bodega.bod_id,
          label: bodega.bod_nombre,
          objName: "bodegaHacia",
        });
      }
    return bodega;
  });
const handleSaveRow = ({exitEditingMode,row,values}) => {
    var qty =0;
    dataItems.map((data,i)=>{
      if(row.original.movd_articulo===data.art_id){
        qty = data.inv_qty;
      }
    })

    if(Number(values.movd_cantidad)<=Number(qty)){
        if(basicModalEditMov){
          update_mov_movimiento_detalle_row({
            movd_cantidad:values.movd_cantidad,
            movd_id:row.original.movd_id, 
            movd_identificador:row.original.movd_identificador, 
          },row.original.movd_identificador)
          exitEditingMode();
        }
        else{
          dataMovimientoDetalle[row.index] = {
          art_upc:row.original.art_upc,
          movd_articulo:row.original.movd_articulo,
          movd_cantidad: values.movd_cantidad,
          movd_id:row.original.movd_id,
          art_descripcion:values.art_descripcion,
          inv_qty:row.original.inv_qty,
        };

        setOBJMovimientoDetalle([...dataMovimientoDetalle]);
        exitEditingMode();
        }
    }
};

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="fullscreen" className="modal-full-large">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Movimiento # {props.mov_id}</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchMovimiento()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
                <>
                {isTabItems?<>
                  <Row>
                    <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                      {dataItems !==undefined?
                      <DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA dataItems={dataItemsFilter} selectItem={selectItem} setTabItems={setTabItems} setFormMovimientoDetalle={setFormMovimientoDetalle} props= {formMovimientoDetalle} usr_a_costo={usr_a_costo}/> :<Label>Cargando...</Label>}
                  </Col>
                </Row>
                </>:<>
                    <form>
                      <Row>
                        <Col xs={2}>
                          <MDBInput
                            id="mov_fecha"
                            type="date"
                            wrapperClass="mb-1"
                            label="* Fecha movimiento"
                            name="mov_fecha"
                            onChange={onChange}
                            defaultValue={props.mov_fecha}
                          />
                        </Col>
                        <Col xs={10}>
                          <MDBInput
                            id="mov_descripcion"
                            wrapperClass="mb-1"
                            label="Descripcion"
                            name="mov_descripcion"
                            onChange={onChange}
                            value={props.mov_descripcion}
                            
                          />
                        </Col>
                      </Row>
                  </form>
                  <Row>
                    <Col xs={6}>
                    <Label>
                      Bodega desde
                    </Label>
                      <Select
                       wrapperClass="mb-1"
                        options={ObjBodegaDesde}
                        onChange={onChangeDropdown}
                        placeholder={props.mov_bodega_desde.length>0?props.mov_bodega_desde_nombre:"Bodega inicio"}
                        maxMenuHeight={180}/>
                    </Col>
                    <Col xs={6}>
                    <Label>
                      Bodega hacia
                    </Label>
                        <Select
                         wrapperClass="mb-1"
                        options={ObjBodegaHacia}
                        onChange={onChangeDropdown}
                        placeholder={props.mov_bodega_hacia.length>0?props.mov_bodega_hacia_nombre:"Bodega final"}
                        maxMenuHeight={180}/>
                    </Col>
                    <Col xs={12} className="mt-2">
                      <Label className="error-label-inventario">
                        - {error_upc}
                      </Label>
                    </Col>
                    <Col xs ={12} className="mt-2">
                      <Row>
                        <Col xs={3} className="d-flex">
                          <MDBInput
                              id="art_upc"
                              wrapperClass="mb-4"
                              label="Codigo"
                              name="art_upc"
                              onChange={onChangeRed_detail}
                              value={formMovimientoDetalle.art_upc}
                              disabled={enableTab}
                              onKeyDown={(e) =>{
                                handleKeyPress(e, props.dcd_articulo);
                              }
                              }
                            />
                          {enableTab===true?null:<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true)}}/>}
                          {enableTab===false && formMovimientoDetalle.art_upc.length>0?<img src={EXIT_IMAGE} className="src-image" alt="..." onClick={()=>{     
                            setFormMovimientoDetalle({
                              movd_id: "",
                              movd_articulo: "",
                              movd_cantidad: "1",
                              movd_identificador: "",
                              art_upc: "",
                              art_descripcion: "",
                            });
                          
                          }}/>:null}
                        </Col>
                        <Col xs={7}>
                        <MDBInput
                            id="art_descripcion"
                            wrapperClass="mb-4"
                            label="Descripcion articulo"
                            name="art_descripcion"
                            disabled={true}
                            onChange={onChangeRed_detail}
                            value={formMovimientoDetalle.art_descripcion}
                          />
                        </Col>
                        <Col xs={2} className="d-flex">
                        <MDBInput
                            id="movd_cantidad"
                            wrapperClass="mb-4"
                            label="Cantidad"
                            name="movd_cantidad"
                            autoFocus ={true}
                            type={"number"}
                            min={"1"}
                            max={Number(props.inv_qty).toFixed(0)}
                            disabled ={formMovimientoDetalle.art_upc.length>0?false:true}
                            onChange={onChangeRed_detail}
                            value={formMovimientoDetalle.art_descripcion.length>0?formMovimientoDetalle.movd_cantidad:""}
                            onKeyDown={(e) =>
                              handleKeyPress(e, formMovimientoDetalle.movd_cantidad)
                            }
                          />
                            {formMovimientoDetalle.art_upc.length>0 ?<img src={ADD_IMAGE}  namebtn="movd_cantidad" className="src-image-2" alt="..." onClick={(e)=>{handleKeyPress(e, formMovimientoDetalle.movd_cantidad,"btn");}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                        </Col>
                        <Col className="modal-add-inventario datatable-factura  css_datatable1">
                        <DATATABLE_COLUMNS_MOVIMIENTO  enableTab={enableTab} dataMovimientoDetalle ={dataMovimientoDetalle} handleSaveRow={handleSaveRow} deleteRow={deleteRow}/>
                        </Col>
                    </Row> 
                    </Col>
                  </Row> 
                  
                </>}   
                </>
            </MDBModalBody>
            <MDBModalFooter>
            {isTabItems?<>
              <Row>
                <Col xs={12} className="text-center">
                <MDBBtn color="danger" onClick={() => {setTabItems(false)}}>
                Cerrar
              </MDBBtn>
                </Col>
              </Row>
            </>:<>
            <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchMovimiento();}}>
                Cerrar
              </MDBBtn>
              {basicModalEditMov?<MDBBtn onClick={() => ( toggleSaveEncabezado())}>
                        Guardar
                      </MDBBtn>:              <MDBBtn onClick={() => ( toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>}

            </>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const RecuentoModal = ({
  dataBodegas,
  onChangeDropdown,
  formDropdown,
  props,
  dataRecuentoDetalle,
  formRecuentoDetalle,
  isOpen,
  basicModalEditRe,
  toggle,
  toggleSave,
  onChange,
  onChangeRed_detail,
  handleKeyPress,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJRecuentoDetalle,
  fetchRecuento,
  dataItems,
  update_red_recuento_detalle_row_re,
  toggleSaveEncabezado,
  dataRecuento,
  selectItem,
  setFormRecuentoDetalle,
  loading,
  usr_sucursal,
  setPrintI,
  usr_a_costo
}) => {
  const [isTabItems, setTabItems] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  var enableTab = true
  var existencia =0;
  var bodegas =dataBodegas.filter((data,i)=>{
    if(usr_sucursal ===data.bod_suc)
    return data
  });
  if(props.re_fecha.length && formDropdown.bod_id.length>0){
    enableTab = false
  }
  const ref = useRef(null);
  if (formRecuentoDetalle.art_descripcion.length>0) {
      // ref.current.focus();
   }
  const [formDetailItem, setFormDetailItem] = useState({
    art_categoria : "",
    art_descripcion : "",
    art_id : "",
    art_img : null,
    art_imgName : "",
    art_itbm_cod_v: "",
    art_itbm_venta: "",
    art_precio: "",
    art_precio2: "",
    art_precio3: "",
    art_referencia: "",
    art_restaurante: "",
    art_upc: "",
    cat_descripcion: "",
    itbm_descripcion: "",
    mar_descripcion: "",
  });
  async function select_detail_articulo({row}) {
    var response = await get_articulo_detail(row.art_id);
    setFormDetailItem({
    art_categoria : row.art_categoria,
    art_descripcion : row.art_descripcion,
    art_id : row.art_id,
    art_img : row.art_img,
    art_imgName :row.art_imgName,
    art_itbm_cod_v:row.art_itbm_cod_v,
    art_itbm_venta: row.art_itbm_venta,
    art_precio: row.art_precio,
    art_precio2: row.art_precio2,
    art_precio3: row.art_precio3,
    art_referencia: row.art_referencia,
    art_restaurante: row.art_restaurante,
    art_upc: row.art_upc,
    cat_descripcion: row.cat_descripcion,
    itbm_descripcion: row.itbm_descripcion,
    mar_descripcion: row.mar_descripcion,
    bodegas:response});
    SetOpenDetailItem(true)
}
const handleSaveRow = ({exitEditingMode,row,values}) => {
  if(basicModalEditRe){
    update_red_recuento_detalle_row_re({
      red_cantidad:values.red_cantidad,
      red_id:row.original.red_id, 
    },row.original.red_identificador)
    exitEditingMode();
    
  }
  else{
    dataRecuentoDetalle[row.index] = {
        art_upc:row.original.art_upc,
        red_articulo:row.original.red_articulo,
        red_cantidad: values.red_cantidad,
        red_id:row.original.red_id,
        art_descripcion:values.art_descripcion,
      };

      setOBJRecuentoDetalle([...dataRecuentoDetalle]);
      exitEditingMode();
  }
};
  if(isOpenDetailItem && formDetailItem.bodegas !== undefined){
    formDetailItem.bodegas.map((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })}
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-full-large"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Inventario # {props.re_id}</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchRecuento()}}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
                <>
                {isTabItems?<>
                 {isOpenDetailItem?<> {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}</>:<Row>
                    <Col xs={12} className="modal-add-inventario datatable-factura css_datatable1">
                      {dataItems !==undefined?
                      <DATATABLE_COLUMNS_LISTA_ITEMS dataItems={dataItems} usr_a_costo={usr_a_costo} selectItem={selectItem} setTabItems={setTabItems}  select_detail_articulo={select_detail_articulo}/> :<Label>Cargando...</Label>}
                  </Col>
                </Row>
                }
                </>:<>
                    <form>
                      <Row>
                        <Col xs={5} sm={4} md={2} className="input-tablet">
                          <MDBInput
                            id="re_fecha"
                            type="date"
                            wrapperClass="mb-2"
                            label="* Fecha documento"
                            name="re_fecha"
                            onChange={onChange}
                            defaultValue={props.re_fecha}
                          />
                        </Col>
                        <Col xs={7} sm={8} md={6} className="input-tablet">
                          <Select
                            options={bodegas}
                            onChange={onChangeDropdown}
                            placeholder={formDropdown.bod_nombre.length===0?"Bodega":"Bodega: "+formDropdown.bod_nombre}
                            maxMenuHeight={150}
                          />
                        </Col>
                        <Col xs={12} sm={12} md={4} className="input-tablet">
                          <MDBInput
                            id="re_descripcion"
                            wrapperClass="mb-2 mt-2"
                            label="Descripcion"
                            name="re_descripcion"
                            onChange={onChange}
                            defaultValue={props.re_descripcion}   
                          />
                        </Col>
                        
                      </Row>
                  </form>
                  <Row>
                    <Col xs={7}>
                      <Label className="error-label-inventario">
                        - {error_upc}
                      </Label>
                    </Col>
                    <Col xs={5}>
                      <Label className="error-label-inventario">
                        ARTÍCULOS: {dataRecuentoDetalle.length}
                      </Label>
                    </Col>
                    <Col xs ={12}>
                      <Row>
                        <Col xs ={8} sm={8} md={4}  className="d-flex input-tablet">
                          <MDBInput
                              id="art_upc"
                              wrapperClass="mb-2"
                              label="Código o referencia"
                              name="art_upc"
                              onChange={onChangeRed_detail}
                              value={formRecuentoDetalle.art_upc}
                              disabled={enableTab}
                              onKeyDown={(e) =>{
                                handleKeyPress(e, props.dcd_articulo);
                              }
                              }
                            />
                          {enableTab===true?null:<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true); SetOpenDetailItem(false)}}/>}
                          {enableTab===false && formRecuentoDetalle.art_upc.length>0?<img src={EXIT_IMAGE} className="src-image" alt="..." onClick={()=>{     
                            setFormRecuentoDetalle({
                              red_id: "",
                              red_articulo: "",
                              red_cantidad: "1",
                              red_identificador: "",
                              art_upc: "",
                              art_descripcion: "",
                            });
                          
                          }}/>:null}
                        </Col>
                        {window.innerWidth<=611?null:<Col xs={5} sm={5} md={5} className="input-tablet">
                        <MDBInput
                            id="art_descripcion"
                            wrapperClass="mb-4"
                            label="Descripción del artículo"
                            name="art_descripcion"
                            disabled={true}
                            onChange={onChangeRed_detail}
                            value={formRecuentoDetalle.art_descripcion}
                          />
                        </Col>}
        
                        <Col xs={4} sm={4} md={3}  className="d-flex input-tablet">
                        <MDBInput
                            id="red_cantidad"
                            wrapperClass="mb-2"
                            label="Cantidad"
                            name="red_cantidad"
                            autoFocus ={true}
                            type={"number"}
                            min={"1"}
                            ref={ref}
                            disabled ={formRecuentoDetalle.art_upc.length>0?false:true}
                            onChange={onChangeRed_detail}
                            value={formRecuentoDetalle.art_descripcion.length>0?formRecuentoDetalle.red_cantidad:""}
                            onKeyDown={(e) =>
                              handleKeyPress(e, formRecuentoDetalle.red_cantidad)
                            }
                          />
                           {formRecuentoDetalle.art_upc.length>0 ?<img src={ADD_IMAGE}  namebtn="red_cantidad" className="src-image-2" alt="..." onClick={(e)=>{handleKeyPress(e, formRecuentoDetalle.red_cantidad,"btn");}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                        </Col>
                        {window.innerWidth<=611?<Col xs={12} sm={12} md={5} className="input-tablet">
                        <MDBInput
                            id="art_descripcion"
                            wrapperClass="mb-2"
                            label="Descripción del artículo"
                            name="art_descripcion"
                            disabled={true}
                            onChange={onChangeRed_detail}
                            value={formRecuentoDetalle.art_descripcion}
                          />
                        </Col>:null}
                        <Col className="modal-add-inventario datatable-factura css_datatable1">
                        <DATATABLE_COLUMNS_RENCUENTO  enableTab={enableTab} dataRecuentoDetalle ={dataRecuentoDetalle} handleSaveRow={handleSaveRow} deleteRow={deleteRow}/>
                        </Col>
                    </Row> 
                    </Col>
                  </Row> 
                  
                </>}   
                </>
            </MDBModalBody>
            <MDBModalFooter>
            {isTabItems?<>
              <Row>
                <Col xs={12} className="text-center">
                <MDBBtn color="danger" onClick={() => {setTabItems(false)}}>
                Cerrar
              </MDBBtn>
                </Col>
              </Row>
            </>:<>
            <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchRecuento();setPrintI(false);}}>
                Cerrar
              </MDBBtn>
              {basicModalEditRe?<MDBBtn onClick={() => ( toggleSaveEncabezado())}>
                        Guardar
                      </MDBBtn>:              <MDBBtn onClick={() => ( toggleSave())} disabled={loading}>
                Guardar
              </MDBBtn>}

            </>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ApartadoModal = ({
  props,
  dataapartadoDetalle,
  propsDCDetail,
  isOpen,
  basicModalEdit,
  toggle,
  toggleSave,
  onChange,
  onChangeap_detail,
  handleKeyPress,
  onBlurs,
  error,
  error_upc,
  isSaveI,
  deleteRow,
  setOBJapartadoDetalle,
  fetchDCapartado,
  update_apd_apartado_detalle_row,
  toggleSaveEncabezado,
  dataClientes,
  selectCliente,
  formClientes
}) => {
  const [isOpenPanelCliente, setPanelCliente] = useState(false);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#9e9e9e',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
  };
  var enableTab = true
  if(props.ap_docn.length>0 && props.ap_fecha.length>0){
    enableTab = false
  }
  const ref = useRef(null);
  if (propsDCDetail.art_descripcion.length>0) {
      // ref.current.focus();
   }

var subtotal=0;
var itbms =0;
var total = 0;

dataapartadoDetalle.map((row,i)=>{
  subtotal = Number(subtotal) + Number((Number(row.dcd_cantidad)*Number(row.dcd_precio)));
  itbms = Number(itbms) + Number(row.dcd_itbms);
  total = Number(subtotal)+Number(itbms);
  return null
})

const handleSaveRow = ({
  exitEditingMode,
  row,
  values
}) => {

if(basicModalEdit){
  update_apd_apartado_detalle_row({
    dcd_cantidad:values.dcd_cantidad,
    dcd_id:row.original.dcd_id, 
    dcd_itbms:Number((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*Number(row.original.art_itbm_compra)),
    dcd_total: Number((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*(1+Number(row.original.art_itbm_compra))),
  },row.original.apd_identificador)
  exitEditingMode();
}
else{
  dataapartadoDetalle[row.index] = {
      art_upc:row.original.art_upc,
      art_descripcion: row.original.art_descripcion,
      art_itbm_compra:row.original.art_itbm_compra,
      dcd_articulo:row.original.dcd_articulo,
      dcd_cantidad: values.dcd_cantidad,
      dcd_itbms: ((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*Number(row.original.art_itbm_compra)).toFixed(2),
      dcd_precio: values.dcd_precio,
      dcd_total: ((Number(values.dcd_cantidad)*Number(row.original.dcd_precio))*(1+Number(row.original.art_itbm_compra))).toFixed(2),
    };

    setOBJapartadoDetalle([...dataapartadoDetalle]);
    exitEditingMode();
}
};

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size="fullscreen" className="modal-full-large">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Apartado</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetchDCapartado()}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {isOpenPanelCliente?<> 
              <Col xs={12}>
              <MDBBtn className="btn-close" color="none" onClick={() => {setPanelCliente(false)}}></MDBBtn>
              </Col>
              <Col className="modal-add-inventario">
              <MaterialReactTable 
                muiTableBodyRowProps={({row}) => ({
                  onClick: () => {
                    selectCliente(row.original)
                  }
                  // selected: selectCliente[row],
                  // sx: {
                  //   cursor: 'pointer'
                  // }
                })} 
                state={{
                  selectCliente
                }}
                      // enableEditing={true}
                      // editDisplayMode="cell"
                      // enableRowActions={true}
                      positionActionsColumn="last"
                      // onEditingRowSave={handleSaveRow}
                      enableGlobalFilter={true} 
                      muiTableBodyRowformFactura={({ row }) => {
                        return {
                          sx: {
                            backgroundColor:
                              row.original.fac_fecha_procesado !== "0000-00-00 00:00:00"
                                ? "rgba(219, 237, 220, 0.78)"
                                : "",
                            fontWeight: "bold",
                          },
                        };
                      }}
                      globalFilterFn="contains"
                      enableFullScreenToggle={false}
                      // styles={customStyles}
                      enableDensityToggle={false}
                      positionGlobalFilter="left"
                      columns={COLUMNS_LISTA_CLIENTE()}
                      data={ dataClientes}
                      enableTopToolbar={true}
                      muiTableContainerformFactura={{
                        sx: {
                          maxHeight: "290px",
                        },
                      }}
                    />
                  </Col></>:<>             <form>
                <Row>
                  <Col>
                  <MDBInput
                      id="cli_ruc"
                      wrapperClass="mb-4"
                      label="CLIENTE"
                      name="cli_ruc"
                      value={formClientes.cli_nombre + " " +formClientes.cli_dv}
                      disabled={true}
                    />
                    <img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setPanelCliente(true);}}/>
                  </Col>
                  <Col xs={12}>
                    <MDBInput
                      id="dc_descripcion"
                      wrapperClass="mb-4"
                      label="Descripcion"
                      name="dc_descripcion"
                      onChange={onChange}
                      defaultValue={props.dc_descripcion}
                      autoFocus ={true}
                    />
                  </Col>
                </Row>
              </form>
              <Row >
              <Col xs={8}>
                    <Label className="error-label-inventario">
                      - {error_upc}
                    </Label>
                  </Col>
              <Col xs={4} className="text-end">
                {
                  basicModalEdit?<MDBBtn className="btn-update-header" onClick={() => ( toggleSaveEncabezado())}>
                  Actualizar encabezado
                </MDBBtn>:null
                }
                  
                  </Col>
                  <Col xs ={12}>
                    <Row>
                    <Col xs={2}>
                  <MDBInput
                      id="art_upc"
                      wrapperClass="mb-4"
                      label="Codigo"
                      name="art_upc"
                      onChange={onChangeap_detail}
                      value={propsDCDetail.art_upc}
                      disabled={enableTab}
                      onKeyDown={(e) =>{
                        handleKeyPress(e, props.dcd_articulo);
                      }
                      }
                    />
                  </Col>
                  <Col xs={6}>
                  <MDBInput
                      id="art_descripcion"
                      wrapperClass="mb-4"
                      label="Descripcion articulo"
                      name="art_descripcion"
                      onChange={onChangeap_detail}
                      value={propsDCDetail.art_descripcion}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                      id="dcd_precio"
                      wrapperClass="mb-4"
                      label="Precio"
                      name="dcd_precio"
                      autoFocus ={true}
                      type={"number"}
                      onChange={onChangeap_detail}
                      value={propsDCDetail.dcd_precio}
                      disabled= {propsDCDetail.art_upc.length>0?false:true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                      id="dcd_cantidad"
                      wrapperClass="mb-4"
                      label="Cantidad"
                      name="dcd_cantidad"
                      type={"number"}
                      min={"1"}
                      ref={ref}
                      disabled ={propsDCDetail.art_upc.length>0?false:true}
                      onChange={onChangeap_detail}
                      value={propsDCDetail.dcd_cantidad}
                      onKeyDown={(e) =>
                        handleKeyPress(e, propsDCDetail.dcd_cantidad)
                      }
                    />
                  </Col>
                <Col className="modal-add-inventario">
                <MaterialReactTable
                globalFilterFn="contains"
                enableEditing = {true}
                editDisplayMode="cell" 
                enableRowActions= {true}
                positionActionsColumn = 'last'
                onEditingRowSave={handleSaveRow}
          muiTableBodyRowProps={({row}) => {
            return ({
            sx: {
               backgroundColor: row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? 'rgba(219, 237, 220, 0.78)' : '',
               fontWeight: 'bold',
            }
          })
        }}
            enableFullScreenToggle={false}
            styles={customStyles}
            enableDensityToggle={false}
            positionGlobalFilter="left"
            columns={COLUMNS_DC_COMPRA_DETALLE(deleteRow,onBlurs)}
            data={enableTab?[]:dataapartadoDetalle}
            enableTopToolbar={false}
            muiTableContainerProps={{
              sx: {
                maxHeight: '290px'
              }
            }}
          />
                </Col>


              </Row>
              <Row className="mt-3">
                  <Col xs={6}>
                  </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_subtotal"
                      wrapperClass="mb-4"
                      label="SUBTOTAL"
                      name="dcd_i_subtotal"
                      autoFocus ={true}
                      value={
                        enableTab?[]:subtotal.toFixed(2)
                      }
                      disabled={true}
                    />
                </Col>
                <Col xs={2}>
                <MDBInput
                 className="input-iventario-totales"
                      id="dcd_i_itbms"
                      wrapperClass="mb-4"
                      label="ITBMS"
                      name="dcd_i_itbms"
                      autoFocus ={true}
                      value={
                        enableTab?[]:itbms.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col xs={2}>
                  <MDBInput
                  className="input-iventario-totales"
                      id="dcd_i_total"
                      wrapperClass="mb-4"
                      label="TOTAL"
                      name="dcd_i_total"
                      autoFocus ={true}
                      value={                 enableTab?[]:total.toFixed(2)
                      }
                      disabled={true}
                    />
                  </Col>
                    </Row>
                  </Col>
   
                </Row></>}
 
            </MDBModalBody>
            <MDBModalFooter>
              <Row>
                <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                <Col xs={12} className="text-center">
                 {isSaveI ? <Label className="success-label" >Guardado</Label> : ""}
                </Col>
              </Row>
              <MDBBtn color="danger" onClick={() => {toggle(false);fetchDCapartado();}}>
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />      Cerrar
              </MDBBtn>
              {basicModalEdit?"":              <MDBBtn onClick={() => ( toggleSave())}>
              <MDBIcon fas icon="save" className="me-1 class-btn-factura d-flex"  />    Guardar
              </MDBBtn>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaCajas= ({
  dataCajas,
  isOpen,
  toggle,
  setCajaData,
  setCajaN
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Seleccione la caja</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                <Col xs={12}  className="col-btn-reportes mt-2 mb-1">
                {dataCajas.map((data)=>{
                  return <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setCajaData(data);setCajaN(data.caj_id);toggle(false)}}>{data.caj_descripcion}</Button>
                })}
                </Col>
              </Row>
            </MDBModalBody>
            <MDBModalFooter>
                {/* <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn> */}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaClienteModal = ({
  dataCliente,
  isOpen,
  toggle,
  selectCliente,
  setModalAddCliente,
  setErrorCliente,
  setFormClientes,
  usr_id
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Clientes</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
            <Col className="modal-add-inventario datatable-factura css_datatable1">
              <MaterialReactTable 
                muiPaginationProps={{
                  showRowsPerPage: false,
                }}
                muiTableBodyRowProps={({row}) => ({
                  onClick: () => {
                      selectCliente(row.original)
                      },
                      sx: {
                        backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        fontWeight: "bold",
                        },
                      })} 
                      renderEmptyRowsFallback={() => (
                        <Container fluid>
                          <Row>
                            <Col xs={12} className="col-no-record label-no-record-fiscal">
                              <Label className="label-no-record">No hay registros que mostrar</Label>
                            </Col>
                          </Row>
                        </Container>
                      )}
                      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth<=611?"68dvh":"57dvh"} }}
                      initialState={{
                          pagination: { pageSize: 30, pageIndex: 0 }
                        }}
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box>
                          <IconButton
                            onClick={() => {
                              setModalAddCliente(true);
                              setErrorCliente("");
                              setFormClientes(STATES_FAC_FACTURA({staneName:"formClientes",usr_id}));
                              toggle(false);
                            }}
                          >
                            <AddBoxIcon />
                          </IconButton>
                        </Box>
                      )}
                      layoutMode="grid" 
                       positionGlobalFilter="left"
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={true}
                      enableFullScreenToggle={false}
                      enableDensityToggle={false}
                      enableTopToolbar={true}
                      enableRowActions={false}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_LISTA_CLIENTE()}
                      data={ dataCliente}
                    />
                  </Col>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ListaOrden = ({
  dataListOrdenes,
  isOpen,
  toggle,
  selectItemOrdenes,
  usr_perfil,
  deleteRow
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lista de ordenes</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              {usr_perfil==="4"?            <Col className="modal-add-inventario datatable-factura">
              {dataListOrdenes !==undefined?
              <DATATABLE_COLUMNS_LISTA_ORDENES selectItemOrdenes ={selectItemOrdenes} dataListOrdenes ={dataListOrdenes}  deleteRow={deleteRow}/>
              :<Label>Cargando...</Label>}
            </Col>:<Col className="modal-add-inventario datatable-factura  css_datatable1">
              {dataListOrdenes !==undefined?
              <DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL selectItemOrdenes ={selectItemOrdenes} dataListOrdenes ={dataListOrdenes} deleteRow={deleteRow}/>
              :<Label>Cargando...</Label>}
            </Col>}
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ListaCotizacion = ({
  dataListCotizacion,
  isOpen,
  toggle,
  selectItemCotizacion
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lista de cotizaciones</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
            <Col className="modal-add-inventario datatable-factura  css_datatable1">
              {dataListCotizacion !==undefined?
              <DATATABLE_COLUMNS_LISTA_COTIZACION selectItemCotizacion ={selectItemCotizacion} dataListCotizacion ={dataListCotizacion}/>
              :<Label>Cargando...</Label>}
                  </Col>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaCreditos = ({
  dataListCreditos,
  isOpen,
  toggle,
  selectCreditosDetalle,
  dataListCreditoDetalle,
  dataListCreditoPago,
  selectCreditosPago,
  addPago,
  deleteCrePago,
  crp_monto_p,
  ObjFrmPago,
  onChangeDropdown,
  formDropDownFPago,
  onChange,
  formListPago,
  setAddFPago,
  dataListpago,
  setFormDropDownFPago,
  setFormListPago,
  setDatalistpago,
  deleteRowFpago,
  setFormPagoCredito,
  formPagoCredito,
  printAbono,
  printFac,
  dataBodyCredito,
  dataCompania_f,
  isPrinting,
  setPrintI
}) => {
  var componentRef = useRef();
  const [isCreditoDetalle, setCreditoDetalle] = useState(false);
  const [isCreditoPago, setCreditoPago] = useState(false);
  const [crp_fac_identificador, setFacIdentificador] = useState(false);
  const [crp_cliente, setCrpCliente] = useState(false);
  const [cli_name, setCliName] = useState(false);
  const [isAbonos, toggleAbonos] = useState(false);

  ObjFrmPago = ObjFrmPago.filter((data)=>{
    if(data.frm_code !=="01"){
      return data
    }
    return null

  })
  const [monto_adeudado, setMontoAdeudado] = useState(false);
  const handleSaveRow = ({
    exitEditingMode,
    row,
    values
  }) => {

  dataListpago[row.index] = {
    list_fpago: row.original.list_fpago,
    list_fpagoName:row.original.list_fpagoName,
    list_identificador:row.original.list_identificador,
    list_monto:Number(values.list_monto).toFixed(2)
  };
    // setFormClientes({...formClientes,cli_limitc:(Number(formClientes.cli_limitc)+Number(row.original.list_monto))-Number(values.list_monto)})
    setDatalistpago([...dataListpago]);
    exitEditingMode();
  }

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{isCreditoDetalle?"Facturas":isCreditoPago?"Pagos":"Créditos"}</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              {isPrinting? 
                  <Row>
                  <Col xs={10}></Col>
                  <Col xs={2} >
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintI(false);
                        // setFormCotCotizacion(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
                        // setOBJCotizacionDetalle([]);
                      }}>
                      <CloseIcon />
                    </IconButton>
                    <ReactToPrint
                            trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                            content={() => componentRef} />
                  </Col>
                  <Col xs={12} >
                    <ComponentToPrintsPDFCredito
                      ref={el => (componentRef = el)}
                      form={dataBodyCredito}
                      dataCompania={dataCompania_f}
                    />
                  </Col>
                </Row>
                  :<Col className="modal-add-inventario datatable-factura  css_datatable1">
              {
              isCreditoDetalle?<>
              <Row>
                <Col xs={12} md={4} className="mb-2">
                  <MDBInput
                  id="cli_name"
                  label="Nombre del cliente"
                  name="cli_name"
                  value={cli_name}
                  disabled={true}/>
                </Col>
                <Col xs={6} md={3} className="mb-2">
                  <MDBInput
                  id="cli_total"
                  label="Total"
                  name="cli_total"
                  value={monto_adeudado}
                  disabled={true}/>
                </Col>
                <Col xs={6} md={3} className="mb-2">
                  <MDBInput
                  id="cli_monto_adeudado"
                  label="Saldo adeudado"
                  name="cli_monto_adeudado"
                  value={(Number(monto_adeudado)-Number(crp_monto_p)).toFixed(2)}
                  disabled={true}/>
                </Col>
                <Col xs={12}>
                  <DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE setFormPagoCredito={setFormPagoCredito} formPagoCredito={formPagoCredito} setCreditoDetalle={setCreditoDetalle} selectCreditosPago ={selectCreditosPago} 
                    dataListCreditoDetalle ={dataListCreditoDetalle} setCreditoPago={setCreditoPago}  setFacIdentificador={setFacIdentificador} printFac={printFac}/>
                </Col>
              </Row>
              </>
              :isCreditoPago? 
              <Row>
                <Col xs={12} md={12}>
               <Label className="fw-bold">
               Factura: {formPagoCredito.fac_id.toString().padStart(10, "0")}
                </Label> 
                </Col>
                <Col xs={4} md={2} className="mb-2">
                <MDBInput
                id="crt_saldo"
                label="Total"
                name="crt_saldo"
                type={"number"}
                min={"1"}
                max={10000}
                step='0.01'
                value={Number(formPagoCredito.crd_monto).toFixed(2)}
                disabled={true}
              />
                </Col>
                <Col xs={4} md={2} className="mb-2">
                <MDBInput
                id="crp_saldo"
                label="Abonado"
                name="crp_saldo"
                type={"number"}
                min={"1"}
                max={10000}
                step='0.01'
                value={Number(formPagoCredito.crp_monto).toFixed(2)}
                disabled={true}
              />
                </Col>
                <Col xs={4} md={2} className="mb-2">
                <MDBInput
                id="crp_saldo"
                label="Saldo"
                name="crp_saldo"
                type={"number"}
                min={"1"}
                max={10000}
                step='0.01'
                value={(Number(formPagoCredito.crd_monto)-Number(formPagoCredito.crp_monto)).toFixed(2)}
                disabled={true}
              />
                </Col>
                <Col xs={4} md={2} className="d-flex">
                {isAbonos?<>
                  <MDBBtn  onClick={() => toggleAbonos(false)} color="success" className="d-flex">
                    <MDBIcon fas icon="credit-card" className="me-1 class-btn-factura d-flex"  />  Pago
                </MDBBtn>

                </>   :<MDBBtn  onClick={() => toggleAbonos(true)} color="danger" className="d-flex">
                    <MDBIcon fas icon="plus-circle" className="me-1 class-btn-factura d-flex"  />  Abonos
                </MDBBtn>}
                
                </Col>
                <Col xs={8} md={3} className="d-flex">
                {isAbonos? <>
                  <MDBBtn  onClick={() => printAbono({type:"recibo"})} className="d-flex">
                    <MDBIcon fas icon="print" className="me-1 class-btn-factura d-flex"  /> Recibo 
                </MDBBtn>
                
                <MDBBtn  onClick={() => printAbono({type:"pdf"})} className="d-flex pdf-btn-margin">
                    <MDBIcon fas icon="file-alt" className="me-1 ml-3 class-btn-factura d-flex"  /> PDF
                </MDBBtn>
                </>
                :null}
               
                </Col>
                <Col xs={1}>
                <IconButton className="float-right-btn"
                      onClick={() => {
                        setCreditoDetalle(true);
                        setCreditoPago(false);
                        setFormDropDownFPago({
                          frm_id: "",
                          frm_code:"",
                          frm_descripcion: ""
                        });
                        setFormListPago(STATES_FAC_FACTURA({staneName:"formListPago"}))
                        setDatalistpago([])
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                </Col>
                <Col xs={12} className="mt-4">
                {isAbonos?<Row>
                  <Col   xs={12} className="mt-4">
                {  <DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO dataListCreditoPago ={dataListCreditoPago} deleteRow={deleteCrePago}/>}
                </Col>
                </Row>:<Row>
                <Col xs={7} md={4}>
                <Select
                options={ObjFrmPago}
                onChange={onChangeDropdown}
                controlShouldRenderValue={formDropDownFPago.frm_descripcion.length>0?true:false}
                maxMenuHeight={180}
              />
                </Col>
                <Col xs={5} md={4} className="d-flex">
                    <MDBInput
                      id="list_monto"
                      wrapperClass="mb-4"
                      label="* Monto"
                      name="list_monto"
                      onChange={onChange}
                      value={formListPago.list_monto}
                      type="number"
                      disabled={formDropDownFPago.frm_descripcion.length>0?false:true}/>
                      {formDropDownFPago.frm_descripcion.length>0 && Number(formListPago.list_monto)>0 ?<img src={ADD_IMAGE} className="src-image-addpago" alt="..." onClick={()=>{setAddFPago(); }}/>:<img src={ADD_IMAGE} className="src-image-addpago" alt="..." 
                  />}
                </Col>
                <Col xs={6}>
                <MDBBtn onClick={() =>  {addPago({crp_fac_identificador,crp_cliente});toggleAbonos(true)}} color = "success" disabled={dataListpago.length>0?false:true}> 
                Guardar abono
              </MDBBtn>
                </Col>
                <Col xs={12} className="datatable-factura">
                <DATATABLE_COLUMNS_LISTA_FPAGO dataListpago ={dataListpago} handleSaveRow ={handleSaveRow} deleteRow ={deleteRowFpago}/>
                </Col>
                </Row>}
                
                </Col>
              </Row>
              :dataListCreditos !==undefined?
              <DATATABLE_COLUMNS_LISTA_CREDITOS setCliName ={setCliName} setFormPagoCredito={setFormPagoCredito} formPagoCredito={formPagoCredito} setMontoAdeudado={setMontoAdeudado} selectCreditosDetalle ={selectCreditosDetalle} dataListCreditos ={dataListCreditos} setCreditoDetalle={setCreditoDetalle}   setCrpCliente ={setCrpCliente}/>
              :<Label>Cargando...</Label>
              
              }
                  </Col>}

            </MDBModalBody>
            <MDBModalFooter>              
              {isAbonos && <MDBBtn  onClick={() => {setCreditoDetalle(true); setCreditoPago(false);setFormDropDownFPago({frm_id: "",frm_code:"",frm_descripcion: ""});setFormListPago(STATES_FAC_FACTURA({staneName:"formListPago"}));setDatalistpago([])}} color="danger">Cerrarrr</MDBBtn>}
              {isCreditoDetalle && <MDBBtn  onClick={() => {setCreditoDetalle(false);setFormDropDownFPago({frm_id: "",frm_code:"",frm_descripcion: ""});setFormListPago(STATES_FAC_FACTURA({staneName:"formListPago"}));setDatalistpago([]);}} color="danger">Cerrar</MDBBtn>}
              <MDBBtn  onClick={() => toggle(false)} color="danger">Cerrar</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

  const ListaFacModal = ({dataListCopia,isOpen,toggle,selectItemFCopia,usr_print}) => {
    const [isOpenDetailCopia, SetOpenDetailCopia] = useState(false);
    const [dataCopiaFactura, setDataCopiaFactura] = useState([]);
    const [fac_selected, setfacSelected] = useState("");
    async function getDetailItem({data}) {
      setfacSelected(data.fac_id)
      var response = await get_list_itemsFactura_detail(data.fac_identificador);
      setDataCopiaFactura({
        factura:response.factura,
        fPago:response.fPago
      });
  }
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lista de facturas</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
              {isOpenDetailCopia && dataCopiaFactura.factura !==undefined?<Col className="modal-add-inventario datatable-factura  css_datatable1">
              <Row>
                <Col xs={12}>
                  {dataListCopia !==undefined?
                  <Row>
                    <Col xs={12} sm={4} className="input-tablet">
                     <MDBInput
                          id="fac_selected"
                          wrapperClass="mb-2"
                          label="# Factura "
                          name="fac_selected"
                          value={fac_selected.toString().padStart(10, "0")}
                          disabled={true}
                        />
                    </Col>
                    <Col xs={12} sm={4} className="input-tablet">
                        <MDBInput
                          id="cli_nombre"
                          wrapperClass="mb-2"
                          label="Cliente"
                          name="cli_nombre"
                          value={dataCopiaFactura.factura[0].cli_nombre}
                          disabled={true}
                        />
                    </Col>
                    <Col xs={12} sm={4} className="input-tablet">
                        <MDBInput
                          id="cli_ruc"
                          wrapperClass="mb-2"
                          label="RUC"
                          name="cli_ruc"
                          value={dataCopiaFactura.factura[0].cli_ruc + dataCopiaFactura.factura[0].cli_dv}
                          disabled={true}
                        />
                    </Col>
                    <Col xs={12} className="input-tablet mb-2">
                      <MDBTextArea 
                          id="fac_text_invoice"
                          name="fac_text_invoice"
                          label="* Descripción"
                          disabled={true}
                          rows={3}
                          value={dataCopiaFactura.factura[0].fac_text_invoice}
                        />
                    </Col>
                    {dataCopiaFactura.fPago.map((data)=>{
                      return <>
                        <Col xs={8} className="input-tablet">
                          <MDBInput
                            id="fcfp_fpago"
                            wrapperClass="mb-2"
                            label="Forma de pago"
                            name="fcfp_fpago"
                            value={data.fcfp_fpago}
                            disabled={true}
                          />
                      </Col>
                      <Col xs={4} className="input-tablet">
                          <MDBInput
                            id="fcfp_monto"
                            wrapperClass="mb-2"
                            label="Monto"
                            name="fcfp_monto"
                            value={Number(data.fcfp_monto).toFixed(2)}
                            disabled={true}
                          />
                      </Col>
                      </>
                    })}
                    <Col xs={12} className="mb-2 mt-2 css_datatable1">
                      <MaterialReactTable 
                        muiTableBodyRowProps={({ row }) => {
                          return {
                            sx: {
                              backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                              fontWeight: "bold",
                            },
                          };
                        }}
                        muiPaginationProps={{
                          showRowsPerPage: false
                        }}
                              renderEmptyRowsFallback={() => (
                                <Col xs={12} className="col-no-record">
                                  <Label className="label-no-record">No hay registros que mostrar</Label>
                                </Col>
                              )}
                      muiSearchTextFieldProps={{
                        placeholder: "Buscar",
                      }}
                        globalFilterFn="contains"
                        muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "41dvh":"43dvh":"47dvh" : "55dvh" } }}//370w 420w, 611w, desktop
                        layoutMode="grid"
                        enableEditing={false}
                        enableColumnActions={false}
                        editDisplayMode="modal"
                        enableBottomToolbar={false}
                        enableTopToolbar={true}
                        enableRowActions={false}
                        positionActionsColumn="last"
                        enablePagination={false}
                        enableSorting={false}
                        enableFilters={true}
                        enableStickyHeader={true}
                        enableFullScreenToggle={false}
                        enableDensityToggle={false}
                        positionGlobalFilter="left"
                        columns={COLUMNS_FAC_FACTURA_DETALLE_COPIA()}
                        data={ dataCopiaFactura.factura}
                        />
                    </Col>
                    <Col sm={3} md={3}>
                    </Col>
                     <Col xs={4} sm={3} md={3}>
                      <MDBInput
                        className="input-iventario-totales"
                        id="fcd_i_subtotal"
                        wrapperClass="mb-2"
                        label="SUBTOTAL"
                        name="fcd_i_subtotal"
                        value={new Decimal(dataCopiaFactura.factura[0].fac_total).minus(new Decimal(dataCopiaFactura.factura[0].fac_itbms)).toFixed(2)}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={4} sm={3} md={3}>
                      <MDBInput
                        className="input-iventario-totales"
                        id="fcd_i_itbms"
                        wrapperClass="mb-2"
                        label="ITBMS"
                        name="fcd_i_itbms"
                        value={new Decimal(dataCopiaFactura.factura[0].fac_itbms).toFixed(2)}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={4} sm={3} md={3}>
                      <MDBInput
                        className="input-iventario-totales"
                        id="fcd_i_total"
                        wrapperClass="mb-2"
                        label="TOTAL"
                        name="fcd_i_total"
                        value={new Decimal(dataCopiaFactura.factura[0].fac_total).toFixed(2)}
                        disabled={true}
                      />
                    </Col>

                  </Row>:<Label>Cargando...</Label>}
                </Col>
              </Row>

              </Col>:<Col className="modal-add-inventario datatable-factura  css_datatable1">
                {dataListCopia !==undefined?<MaterialReactTable 
                    initialState={{
                      pagination: { pageSize: 30, pageIndex: 0 },
                    }}
                    muiPaginationProps={{showRowsPerPage: false}}
                    renderEmptyRowsFallback={() => (
                      <Col xs={12} className="col-no-record">
                        <Label className="label-no-record">No hay registros que mostrar</Label>
                      </Col>
                    )}
                      muiSearchTextFieldProps={{
                        placeholder: "Buscar",
                      }}
                    globalFilterFn="contains"
                    muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "64dvh":"70dvh":"71dvh" : "57dvh" } }}//370w 420w, 611w, desktop
                       
                    muiTableBodyRowProps={({ row }) => {
                    return {
                      sx: {
                        backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        fontWeight: "bold",
                      },
                    };
                  }}
                  enableStickyHeader={true}
                  positionActionsColumn="last"
                  enableGlobalFilter={true} 
                  enableFullScreenToggle={false}
                  enableColumnActions={false}
                  enableEditing={false}
                  enableRowActions={false}
                  enablePagination={true}
                  enableSorting={false}
                  enableFilters={true} 
                  enableDensityToggle={false}
                  positionGlobalFilter="left"
                  enableTopToolbar={true}
                  columns={COLUMNS_LISTA_FACTURA(selectItemFCopia,getDetailItem,SetOpenDetailCopia,usr_print)}
                  data={ dataListCopia}
                />:<Label>Cargando...</Label>}
              </Col>}

            </MDBModalBody>
            <MDBModalFooter>
               {isOpenDetailCopia && dataCopiaFactura.factura !==undefined? <MDBBtn  onClick={() => {setDataCopiaFactura([]);SetOpenDetailCopia(false)}} color="danger">Cerrar</MDBBtn>:null} 
               {isOpenDetailCopia ===false?<MDBBtn  onClick={() => toggle(false)} color="danger">Cerrar</MDBBtn>:null} 
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ModalReporteZ = ({props,isOpen,state,handleOnChangeDate,toggle,printReceipt,usr_print}) => {
    const [tabsActive, setTabsActive] = useState("tab1");
    const handleTabClick = (value) => {
    if (value === tabsActive) {
      return;
    }
    setTabsActive(value);
  };

  var componentRef = useRef();
  const [isPrinting, setPrintI] = useState(false);
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Informe  de ventas</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody>
            <Row>
                  {isPrinting?<>                    <Col xs={10}></Col>
                    <Col xs={2} >
                      <IconButton className="float-right-btn"
                        onClick={() => {
                          setPrintI(false);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <ReactToPrint
                        trigger={() => <button className="btn-print">   <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                        content={() => componentRef} />
                    </Col>
                    <Col xs={12} className="text-center scrol-table2">
                      <Componentprint_report_x
                        ref={el => (componentRef = el)}
                        props={props}
                        state={state}
                      />
                    </Col></>:<><Col xs={12} md={5} className={"text-center col-calendar"} >
                <DateRange 
                  onChange={handleOnChangeDate}
                  showSelectionPreview={false}
                  moveRangeOnFirstSelection={false}
                  editableDateInputs={true}
                  dateDisplayFormat="yyyy-MM-dd-"
                  ranges={state}
                  maxDate={new Date()} 
                  direction="vertical"
                  className="box-calendar"/>
              </Col>
              <Col xs={12} md={7}>
                <MDBTabs className="d-flex-none custom-navs">
                  <Row>
                    <Col xs={12} className="mt-3">
                      <Row>
                        <Col xs={6} >
                          <MDBTabsLink onClick={() => handleTabClick("tab1")} active={tabsActive === "tab1"} className="padding-2porc">
                            <MDBIcon fas icon="money-bill" className="me-2" /> Registro de ventas 
                          </MDBTabsLink>
                        </Col>
                        <Col xs={6}>
                          <MDBTabsLink onClick={() => handleTabClick("tab2")} active={tabsActive === "tab2"} className="padding-2porc">
                            <MDBIcon fas icon="cash-register" className="me-2" /> Anulaciones
                          </MDBTabsLink>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </MDBTabs>
                <MDBTabsContent>
                  <MDBTabsPane show={tabsActive === "tab2"}>
                    <Row  className="overflow-anulacion">
                        {props.length !==0?props.anulacion.map((data)=>{
                          return <>
                          <Col xs={12}>
                          <Row>
                            <Col xs={4} md={3} className="input-tablet mt-2">
                              <MDBInput
                                id="fac_id"
                                wrapperClass="mb-2"
                                label="# Factura"
                                name="fac_id"
                                value={data.fac_id.toString().padStart(10, "0")}
                                disabled={true}/>
                            </Col>
                            <Col xs={4} md={3}className="input-tablet  mt-2">
                                <MDBInput
                                  id="fac_fecha"
                                  wrapperClass="mb-2"
                                  label="Fecha factura"
                                  name="fac_fecha"
                                  value={data.fac_fecha}
                                  disabled={true}/>
                            </Col>
                            <Col xs={4} md={3}className="input-tablet mt-2">
                                <MDBInput
                                  id="fac_date_anulacion"
                                  wrapperClass="mb-2"
                                  label="Fecha anulación"
                                  name="fac_date_anulacion"
                                  value={data.fac_date_anulacion}
                                  disabled={true}/>
                            </Col>
                            <Col xs={4}  md={3}className="input-tablet mt-2">
                                <MDBInput
                                  id="fcd_total"
                                  wrapperClass="mb-2"
                                  label="Monto"
                                  name="fcd_total"
                                  value={Number(data.fcd_total).toFixed(2)}
                                  disabled={true}/>
                            </Col>
                            <Col xs={8} className="input-tablet mt-2">
                                <MDBInput
                                  id="fac_motivo_anulacion"
                                  wrapperClass="mb-2"
                                  label="Motivo de la anulación"
                                  name="fac_motivo_anulacion"
                                  value={data.fac_motivo_anulacion}
                                  disabled={true}/>
                            </Col>  
                            </Row></Col>
                
                            </>
                          }):""}
                      </Row>
                  </MDBTabsPane>
                  <MDBTabsPane show={tabsActive === "tab1"}>
                    <Row className="overflow-anulacion">
                        {props.length !==0?props.montos_fpago.map((data)=>{
                        return <>
                          <Col xs={9} className="input-tablet mt-2">
                            <MDBInput
                              id="fcfp_fpago"
                              wrapperClass="mb-2"
                              label="Forma de pago"
                              name="fcfp_fpago"
                              value={data.fcfp_fpago}
                              disabled={true}/>
                          </Col>
                          <Col xs={3} className="input-tablet mt-2">
                            <MDBInput
                              id="fcfp_monto"
                              wrapperClass="mb-2"
                              label="Monto"
                              name="fcfp_monto"
                              value={Number(data.fcfp_monto).toFixed(2)}
                              disabled={true} />
                          </Col>
                        </>
                      }):""}
                    </Row>
                  </MDBTabsPane>
                </MDBTabsContent>
                
            </Col>
                      
                    <Col xs={12}><Label className="title-informe">TOTALES -  Fecha: {moment(state[0].startDate).format("YYYY-MM-DD")} - {moment(state[0].endDate).format("YYYY-MM-DD")}</Label></Col>
{props.length!==0?<>                    

                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="crp_monto"
                        wrapperClass="mb-2"
                        label="Abonos a crédito"
                        name="crp_monto"
                        value={props.abonos.length !==0 ?Number(props.abonos[0].crp_monto).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="fcd_total"
                        wrapperClass="mb-2"
                        label="Ventas exento"
                        name="fcd_total"
                        value={props.exentos.length !==0 ?Number(props.exentos[0].fcd_total).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={8} className="input-tablet">
                      <MDBInput
                        id="usr_nombre"
                        wrapperClass="mb-2"
                        label="NOMBRE"
                        name="usr_nombre"
                        value={props.montos_totales.length !==0 ?props.montos_totales[0].usr_nombre:"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={4} className="input-tablet">
                      <MDBInput
                        id="fac_caja"
                        wrapperClass="mb-2"
                        label="CAJA"
                        name="fac_caja"
                        value={props.montos_totales.length !==0 ?props.montos_totales[0].fac_caja:"0"}
                        disabled={true}/>
                    </Col>

                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="montos_itbms"
                        wrapperClass="mb-2"
                        label="I.T.B.M.S"
                        name="montos_itbms"
                        value={props.montos_totales.length !==0 ?Number(props.montos_totales[0].fcd_itbms).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>
                    <Col xs={6} className="input-tablet">
                      <MDBInput
                        id="montos_totales"
                        wrapperClass="mb-2"
                        label="Totales"
                        name="montos_totales"
                        value={props.montos_totales.length !==0 ?Number(props.montos_totales[0].fcd_total).toFixed(2):"0.00"}
                        disabled={true}/>
                    </Col>

                                        
                    </>:null

                      }</>}
            </Row>
            </MDBModalBody>
           <MDBModalFooter>
            {(usr_print ==="4"||usr_print ==="2")&& <MDBBtn onClick={() => {printReceipt()}}>
                <MDBIcon fas icon="print" className="me-1" />      Recibo
              </MDBBtn>}
              
              <MDBBtn onClick={() => {setPrintI(true)}}>
                <MDBIcon fas icon="file-alt" className="me-1" />      PDF
              </MDBBtn>
              <MDBBtn  onClick={() => {toggle(false)}} color="danger" className="d-flex">
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />  Cerrar
              </MDBBtn>

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const ListaItemModal = ({
  props,
  usr_a_costo,
  isOpen,
  toggle,
  selectItem,
  isDetailItem,
  select_detail_articulo,
  isDetailOpen,
  formDetailItem,
  SetOpenDetailItem
}) => {
   var existencia =0;
   if(isDetailItem){
  formDetailItem.bodegas((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })
   }

  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Articulos</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => isDetailOpen?SetOpenDetailItem(false):toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                {isDetailOpen?            <Col >
                <Row>
                  {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}
                </Row>
                  </Col>:
                  <Col key ={"12345"} className="modal-add-inventario datatable-factura css_datatable1">
                    {props !==undefined?isDetailItem?"":<MaterialReactTable 
                          muiPaginationProps={{
                          showRowsPerPage: false,
                        }}
                    displayColumnDefOptions={{
                      
                      "mrt-row-actions": {
                        header: "OPCIONES",
                        size: window.innerWidth <= 370?75:55,
                        maxSize: window.innerWidth <= 370?75:55,
                        minSize: window.innerWidth <= 370?75:55,
                        muiTableBodyCellProps: {
                          sx: {
                            display: "flex",
                            justifyContent: "center",
                            width:"70px",
                            alignItems: "center",
                            "& button": {
                              marginX:  window.innerWidth <= 430 ? "4px" : "4px", 
                            },
                          },
                        },
                        muiTableHeadCellProps: {
                          sx: {
                            textAlign: "center",
                          },
                        },
                      },
                    }}
                      initialState={{
                          pagination: { pageSize: 30, pageIndex: 0 },
                          columnVisibility: { art_restaurante: MODULO_RESTAURANTE,art_costo:usr_a_costo==="1"?true:false },
                        }}
                      muiTableBodyRowProps={({row}) => ({
                        sx: {
                          backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        },
                      })} 
                        renderRowActions={({ row,table }) => {
                        return <Box className="width-box-delete-cotizacion mx-auto d-flex">
                          <IconButton onClick={() => {selectItem({art_upc:row.original.art_upc,barcode:false, modalItem:false})}}>
                            <AddBoxIcon/>
                          </IconButton>
                          <IconButton  onClick={()=>{select_detail_articulo({row:row.original});}}>
                            <SearchIcon/>
                          </IconButton>
                        </Box>
                        }}
                      globalFilterFn="contains"
                      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "64dvh":"67dvh":"70dvh" : "57dvh" } }}//370w 420w, 611w, desktop
                      layoutMode="grid" 
                      renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
                      enableEditing={false}
                      enableColumnActions={false}
                      editDisplayMode="cell"
                      enableBottomToolbar={true}
                      enableTopToolbar={true}
                      enableDensityToggle={false}
                      enableRowActions={true}
                      positionActionsColumn="last"
                      enablePagination={true}
                      enableSorting={false}
                      enableFilters={true} 
                      enableStickyHeader={true}
                      columns={COLUMNS_LISTA_ITEMS()}
                      data={ props}
                    />:<Label>Cargando...</Label>}
                  </Col>}

              </Row>

            </MDBModalBody>
           <MDBModalFooter>
              <MDBBtn  onClick={() => {isDetailOpen?SetOpenDetailItem(false):toggle(false)}} color="danger" className="d-flex">
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />  Cerrar
              </MDBBtn>

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const PagarModal = ({
  deleteRow,
  setDatalistpago,
  deleteFpago,
  formDropDownFPago,
  setAddFPago,
  onChangeDropdown,
  dataListpago,
  formListPago,
  ObjFrmPago,
  isOpen,
  toggle,
  toggleSave,
  toggleSavePr,
  onChange,
  total,
  error,
  formClientes,
  setFormClientes,
  loading,
  usr_print,
  dataGarantia,
  formGarantia,
  setFormGarantia,
  onChangePagar,
  dataRetencion,
  setFormRetencion,
  formRetencion,
  dataFacturaDetalle,
  formFactura,
  onChangeFac,
  setFormListPago,
  usr_perfil
}) => { 
  var flag_descuento = false;
  dataFacturaDetalle.map((data)=>{
    if(data.fcd_descuento_number!==""){
      flag_descuento = true;
    }
  })
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickGarantia = (event) => {
  setAnchorEl(event.currentTarget);
};
const handleCloseGarantia = () => {
  setAnchorEl(null);
};
  var monto =0;
  var showLimitC=false;
  if(formClientes.cli_credito==="1"){
    console.log("mm")
    showLimitC= true;
  }
  console.log(formClientes.cli_credito)
  dataListpago.map((data,i)=>{
    monto = monto + Number(data.list_monto)
    // if(formClientes.cli_credito==="1"){
    //   showLimitC= true;
    // }
    return null
  });
    const handleSaveRow = ({
      exitEditingMode,
      row,
      values
    }) => {

    dataListpago[row.index] = {
      list_fpago: row.original.list_fpago,
      list_fpagoName:row.original.list_fpagoName,
      list_identificador:row.original.list_identificador,
      list_monto:Number(values.list_monto).toFixed(2)
    };
      setFormClientes({...formClientes,cli_limitc:(Number(formClientes.cli_limitc)+Number(row.original.list_monto))-Number(values.list_monto)})
      setDatalistpago([...dataListpago]);
      exitEditingMode();
    }
  
   const onKeyPressPagar = button => {
      if (button === "{enter}") setAddFPago();
    };

    const greekLayout = {
        theme: "hg-theme-default hg-layout-numeric numeric-theme",
        default: ["1 2 3", "4 5 6", "7 8 9", ". 0 {backspace}","{enter}"], 
        shift: ["{1Dolar} {5Dolar} {10Dolar}", "20Dolar 50Dolar 100Dolar", "& * (", "{shift} ) +"],
    }
    console.log(RECIBO_ENABLED)
    console.log(usr_print)
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Cobrar</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              {window.innerWidth<=611?<>
              <Row>
                <Col xs={12} className="d-ruby col-btn-reportes">
                  {ObjFrmPago.map((data,i)=>{
                      return <MDBBtn  onClick={() => {
                        if (formDropDownFPago.frm_descripcion.length > 0) {
                          setFormListPago({...formListPago,
                            list_monto: ((total - monto)>=0?(total - monto):0).toFixed(2)
                          });
                          if(formListPago.list_monto.length>0){
                      setAddFPago();
                          }
                          
                        } else {
                          onChangeDropdown(data);
                        }
                      }} color={formDropDownFPago.frm_code === data.frm_code?"primary":"secondary"} className="btn-payment btn-reporte_x " >
                      {data.icon==="yappy"?<img src={YAPPY_IMAGE} className="yappy-img-payment" alt="..."/>:<MDBIcon fas icon={data.icon} className="me-1 class-btn-factura d-flex"  />}
                      <span >{ data.label}</span> 
                     
                    </MDBBtn>
                  })}
                </Col>
                <Col xs={12}>
                  <Row>
                    <Col xs={6} className="d-flex input-tablet">
                      <MDBInput
                        id="list_monto"
                        wrapperClass="mb-4"
                        label="* Monto"
                        name="list_monto"
                        onChange={onChange}
                        value={formListPago.list_monto}
                        type="number"
                        disabled={formDropDownFPago.frm_descripcion.length>0?false:true}/>
                        {formDropDownFPago.frm_descripcion.length>0 && Number(formListPago.list_monto)>0 ?<img src={ADD_IMAGE} className="src-image-addpago2" alt="..." onClick={()=>{setAddFPago();}}/>:<img src={ADD_IMAGE} className="src-image-addpago2" alt="..."  />}
                    </Col>
                    <Col xs={6}>
                      {showLimitC ?<MDBInput
                        id="cli_limitc"
                        wrapperClass="mb-4"
                        label="Límite de crédito"
                        name="cli_limitc"
                        value={Number(formClientes.cli_limitc).toFixed(2)}
                        type="number"
                        disabled={true}
                      />:null}</Col>
                    <Col xs={6} className="d-flex">
                      {dataGarantia.length>1?<>   
                        <MDBBtn className="btn-waranty d-flex"
                          id="basic-button"
                          aria-controls={open ? 'basic-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                          onClick={handleClickGarantia}
                          disabled ={false}>
                          <Row className="mx-auto">
                            <Col xs={6} className="text-center d-flex">
                              <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                              Garantía
                            </Col>
                          </Row>
                        </MDBBtn>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleCloseGarantia}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}>
                            { dataGarantia.map((data,i)=>{
                              return <>
                          <MenuItem onClick={()=>{setFormGarantia({gr_name:formGarantia.gr_name+"\n"+data.gr_name,gr_descripcion:formGarantia.gr_descripcion+"\n"+data.gr_descripcion}); handleCloseGarantia()}}>{data.gr_name}</MenuItem>
                              </>

                            })}
                        </Menu>
                              </>:""}
                              <img src={EXIT_IMAGE} className="src-image-w2" alt="..." 
                        onClick={()=>{      setFormGarantia({gr_name:"",gr_descripcion:""})}}/>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12}>
                  <Row>
                    <Col xs ={12}>
                      <Row>
                        {dataRetencion.length>1?<Col xs={12}>
                        <Label className="padd-mar-u l-retencion">
                          {"Retención :" +formClientes.re_desc}
                          </Label>
                        
                        </Col>:""   }
                        {dataGarantia.length>1?<Col xs={12}>
                        <Label className="padd-mar-u l-retencion">
                          {"Garantia :"+formGarantia.gr_name}
                          </Label>
                        
                        </Col>:""   }
                      </Row>
                    </Col>
                    <Col xs ={12} className="input-tablet">
                      <Row>
                        <Col xs={12}>
                        <MDBTextArea
                            id="fac_text_invoice"
                            name="fac_text_invoice"
                            label="Información complementaria"
                            rows={3}
                            onChange={onChangeFac}
                            value={formFactura.fac_text_invoice}
                          />
                          </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                  <Col xs={12} className="datatable-factura mt-2">
                  <DATATABLE_COLUMNS_LISTA_FPAGO dataListpago ={dataListpago} handleSaveRow ={handleSaveRow} deleteRow ={deleteRow}/>
                  </Col>
                 <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                  <Col xs={12} className="mt-3 col-btn-reportes2">
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="total"
                      wrapperClass="mb-2"
                      label="TOTAL"
                      name="total"
                      autoFocus={true}
                      value={total.toFixed(2)}
                      disabled={true}
                    />

                  
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="monto"
                      wrapperClass="mb-2"
                      label="PAGADO"
                      name="monto"
                      autoFocus={true}
                      value={monto.toFixed(2)}
                      disabled={true}
                    />
                
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="faltante"
                      wrapperClass="mb-2"
                      label="FALTANTE"
                      name="faltante"
                      autoFocus={true}
                      value={((total - monto)>=0?(total - monto):0).toFixed(2)}
                      disabled={true}
                    />
                  
                    <MDBInput
                      className="input-iventario-totales btn-reporte_x text-end"
                      id="vuelto"
                      wrapperClass="mb-2"
                      label="VUELTO"
                      name="vuelto"
                      autoFocus={true}
                      value={((monto- total)<=0?0:(monto- total)).toFixed(2)}
                      disabled={true}
                    />
                  </Col>

                </Row>
              </>:<><Row>
                <Col xs={4} className="d-ruby min-height-235">
                {/* <MDBInput
                  id="fcd_descuento_number"
                  wrapperClass="mb-4"
                  label="% Descuento"
                  name="fcd_descuento_number"
                  value={Number(dataFacturaDetalle.fcd_descuento_number)}
                  type="number"
                  disabled={true}
                /> */}
                {
                  
                  ObjFrmPago.map((data,i)=>{
                    return <MDBBtn   onClick={() => {
  if (formDropDownFPago.frm_descripcion.length > 0) {
    setFormListPago({...formListPago,
      list_monto: ((total - monto)>=0?(total - monto):0).toFixed(2)
    });
    if(formListPago.list_monto.length>0){
setAddFPago();
    }
    
  } else {
    onChangeDropdown(data);
  }
}} color={formDropDownFPago.frm_code === data.frm_code?"primary":"secondary"} className="btn-payment">
                    {data.icon==="yappy"?<img src={YAPPY_IMAGE} className="yappy-img-payment" alt="..."/>:<MDBIcon fas icon={data.icon} className="me-1 class-btn-factura d-flex"  />}
                    
                     <span className="pl-16">{ data.text}</span> 
                    </MDBBtn>
                  })
                }
                </Col>
                <Col xs={2}>
                <Row>
                  <Col xs={12} className="d-flex">
                  <MDBInput
                      id="list_monto"
                      wrapperClass="mb-4"
                      label="* Monto"
                      name="list_monto"
                      onChange={onChange}
                      value={formListPago.list_monto}
                      type="number"
                      disabled={formDropDownFPago.frm_descripcion.length>0?false:true}
                    />
                    {formDropDownFPago.frm_descripcion.length>0 && Number(formListPago.list_monto)>0 ?<img src={ADD_IMAGE} className="src-image-addpago2" alt="..." 
                      onClick={()=>{setAddFPago();}}
                      />:<img src={ADD_IMAGE} className="src-image-addpago2" alt="..." 
                      />}
                    </Col>
                  <Col xs={12}>
                    {showLimitC ?<MDBInput
                      id="cli_limitc"
                      wrapperClass="mb-4"
                      label="Límite de crédito"
                      name="cli_limitc"
                      value={Number(formClientes.cli_limitc).toFixed(2)}
                      type="number"
                      disabled={true}
                    />:null}</Col>
                  <Col xs={12} className="d-flex">
                  {dataGarantia.length>1?<>   
                      <MDBBtn 
                      className="btn-waranty d-flex"
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickGarantia}
                        disabled ={false}>
                        <Row className="mx-auto">
                          <Col xs={12} className="text-center d-flex">
                          <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                          Garantía
                          </Col>
                        </Row>
                        </MDBBtn>
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseGarantia}
                                MenuListProps={{
                                  'aria-labelledby': 'basic-button',
                                }}>
                                  { dataGarantia.map((data,i)=>{
                                    return <>
                                <MenuItem onClick={()=>{setFormGarantia({gr_name:formGarantia.gr_name+"\n"+data.gr_name,gr_descripcion:formGarantia.gr_descripcion+"\n"+data.gr_descripcion}); handleCloseGarantia()}}>{data.gr_name}</MenuItem>
                                    </>

                                  })}
                              </Menu>
                              </>:""}
                              <img src={EXIT_IMAGE} className="src-image-w2" alt="..." 
                        onClick={()=>{      setFormGarantia({gr_name:"",gr_descripcion:""})}}/></Col>
                </Row>
                </Col>
                <Col xs={6}>
                {formDropDownFPago.frm_descripcion.length>0 ?<Keyboard
                  // layoutName={state.layoutName}
                  onChange={onChangePagar}
                  onKeyPress={onKeyPressPagar}
                  layout= {greekLayout}
                  disabled={formDropDownFPago.frm_descripcion.length>0?false:true}
                  display={{"{enter}": "↵","{backspace}": "⌫",}}/>:null}
                </Col>
                <Col xs={12}>
                <Row>
                  <Col xs ={6}>
                  <Row>
                    {dataRetencion.length>1?                <Col xs={12}>
                    <Label className="padd-mar-u">
                      {"Retención :" +formClientes.re_desc}
                      </Label>
                    
                    </Col>:""   }
                    {dataGarantia.length>1?                <Col xs={12}>
                    <Label className="padd-mar-u">
                      {"Garantia :"+formGarantia.gr_name}
                      </Label>
                    
                    </Col>:""   }
                  </Row>
                  </Col>
                   <Col xs ={6}>
                   <Row>
                     <Col xs={12}>
                     <MDBTextArea
                        id="fac_text_invoice"
                        name="fac_text_invoice"
                        label="Información complementaria"
                        rows={3}
                        onChange={onChangeFac}
                        value={formFactura.fac_text_invoice}
                      />
                      </Col>
                   </Row>
                   </Col>
                </Row>
                </Col>
                <Col xs={12} className="datatable-factura mt-2">
                <DATATABLE_COLUMNS_LISTA_FPAGO dataListpago ={dataListpago} handleSaveRow ={handleSaveRow} deleteRow ={deleteRow}/>
                </Col>
                <Row className="mt-3">
                {/* <Col xs={1}></Col> */}
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="total"
                      wrapperClass="mb-2"
                      label="TOTAL"
                      name="total"
                      autoFocus={true}
                      value={total.toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="monto"
                      wrapperClass="mb-2"
                      label="MONTO PAGADO"
                      name="monto"
                      autoFocus={true}
                      value={monto.toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="faltante"
                      wrapperClass="mb-2"
                      label="FALTANTE"
                      name="faltante"
                      autoFocus={true}
                      value={((total - monto)>=0?(total - monto):0).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                    <MDBInput
                      className="input-iventario-totales"
                      id="vuelto"
                      wrapperClass="mb-2"
                      label="VUELTO"
                      name="vuelto"
                      autoFocus={true}
                      value={((monto- total)<=0?0:(monto- total)).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={12} className="text-center">
                  <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                </Col>
                </Row>
              </Row></>}

              
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn  onClick={() => toggle(false)} color="danger" className="d-flex btn-pagar">
              <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />  Cerrar
              </MDBBtn>
              {/* usr_print 1. pdf 2. recibo 3. recibo no fiscal 4. factura electronica PDF y RECIBO  tipo 0 => recibo, tipo 1 =>electronica	///1. administrador 2. vendedor 3. restaurante tablet 4. restaurante principal	 */}
              {/* {usr_print==="4"&&<><MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:true,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. PDF
              </MDBBtn>
              <MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:false,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. recibo
              </MDBBtn>
              </>} */}
              {(usr_print==="1" || usr_print==="4")&&<MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:true,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. PDF
              </MDBBtn>}
              {(usr_print==="2" || usr_print==="4")&&<MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"1",pdf:false,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
                Factura E. recibo
              </MDBBtn>}
              {(RECIBO_ENABLED===true && usr_perfil !=="4")&&<MDBBtn className="btn-pagar" onClick={() =>  (parseFloat(total) - parseFloat(monto.toFixed(2)))>0?null:toggleSave({tipo:"0",pdf:false,prefactura:false})} color = {(total - monto)>0?"warning":"success"} disabled={loading}>
               {RECIBO_NAME}
              </MDBBtn>}

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const CotizacionModal = ({
 formCotizacion,
 isOpen,
 toggle,
 onChange,
 error,
 error_upc,
 basicModalEdit,
 toggleSaveEncabezado,
 onChangeCot_detail,
 handleKeyPress,
 formCotCotizacionDetalle,
 propsDropdown,
 onChangeDropdown,
 OBJCotizacionDetalle,
 deleteRow,
 update_cotd_cotizacion_detalle_row,
 setOBJCotizacionDetalle,
 fetch_cot_cotizacion,
 toggleSave,
 isSaveI,
 selectCliente,
 dataCliente,
 formClientes,
 onChangeCliente,
 setFormClientesBlank,
 onClickSaveCliente,
 selectItem,
 dataItems,
 isTabAddClientes,
setTabAddClientes,
setFormClientes,
setError,
onClickUpdateClient,
usr_precio,
setPrecio,
formPrecio,
handleOnChangeCheckBox,
loading,
dataGarantia,
formCotCotizacion,
setFormCotCotizacion,
dataRetencion
}) => {
  const [anchorElRe, setAnchorElRe] = React.useState(null);
  const openRe = Boolean(anchorElRe);
  const [formDetailItem, setFormDetailItem] = useState({
    art_categoria : "",
    art_descripcion : "",
    art_id : "",
    art_img : null,
    art_imgName : "",
    art_itbm_cod_v: "",
    art_itbm_venta: "",
    art_precio: "",
    art_precio2: "",
    art_precio3: "",
    art_referencia: "",
    art_restaurante: "",
    art_upc: "",
    cat_descripcion: "",
    itbm_descripcion: "",
    mar_descripcion: "",
  });

  var existencia = 0;
  const handleClickRetencion = (event) => {
     event.preventDefault()
    setAnchorElRe(event.currentTarget);
     
  };
  const handleCloseRetencion = () => {
    setAnchorElRe(null);
  };

  const [anchorElGr, setAnchorElGr] = React.useState(null);
  const openGR = Boolean(anchorElGr);
  const handleClickGarantia = (event) => {
        event.preventDefault();
    setAnchorElGr(event.currentTarget);
  };
  const handleCloseGarantia = () => {
    setAnchorElGr(null);
  };
  const inputCantidad =useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [isTabClientes, setTabClientes] = useState(false);
  const [isTabImageView, setTabImgView] = useState(false);
  const [isTabItems, setTabItems] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  const [formImg, setFormImg] = useState({
    imgUrl: "",
    img_name: "",
    art_upc:"",
    art_referencia:"",
    cotd_itbms:"",
    cotd_descuento:"",
    cotd_cantidad:""
  });
  var enableTab = true
  var subtotal = new Decimal(0);
  var itbms = new Decimal(0);
  var total = new Decimal(0);

  if(isOpenDetailItem && formDetailItem.bodegas !== undefined){
    formDetailItem.bodegas.map((data)=>{
    existencia = existencia+Number(data.inv_qty)
  })}

  if(formCotizacion.cot_fecha.length>0 && formClientes.cli_id.toString().length>0){
    enableTab = false
  }
  async function select_detail_articulo({row}) {
     var response = await get_articulo_detail(row.art_id);
      setFormDetailItem({
      art_categoria : row.art_categoria,
      art_descripcion : row.art_descripcion,
      art_id : row.art_id,
      art_img : row.art_img,
      art_imgName :row.art_imgName,
      art_itbm_cod_v:row.art_itbm_cod_v,
      art_itbm_venta: row.art_itbm_venta,
      art_precio: row.art_precio,
      art_precio2: row.art_precio2,
      art_precio3: row.art_precio3,
      art_referencia: row.art_referencia,
      art_restaurante: row.art_restaurante,
      art_upc: row.art_upc,
      cat_descripcion: row.cat_descripcion,
      itbm_descripcion: row.itbm_descripcion,
      mar_descripcion: row.mar_descripcion,
      bodegas:response});
      SetOpenDetailItem(true)
  }
const viewImage=({row}) =>{
  setFormImg({imgUrl:imgURLocalImage + row.art_imgName,
    img_name:row.cotd_art_descripcion,
    art_upc:row.art_upc,
    art_referencia:row.art_referencia,
    cotd_itbms:row.cotd_itbms,
    cotd_descuento:row.cotd_descuento,
    cotd_cantidad:row.cotd_cantidad
  });
  setTabImgView(true);
}
  const handleSaveRow = ({exitEditingMode,row,values}) => {
    var cotd_descuento_number =0;
    if(row.original.cotd_descuento_number===""){
      cotd_descuento_number = values.cotd_descuento;
    }
    var subtotal = new Decimal(values.cotd_cantidad).times(new Decimal(values.cotd_precio)).toDecimalPlaces(2,Decimal.ROUND_UP);
    var subdescuento = new Decimal(values.cotd_precio).times(new Decimal(values.cotd_descuento_number===""?0:values.cotd_descuento_number)/100);
    
       var descuento =((new Decimal(values.cotd_cantidad).times(new Decimal(subdescuento.toDecimalPlaces(2,Decimal.ROUND_DOWN).toFixed(2)))).toDecimalPlaces(2,Decimal.ROUND_DOWN));
    // var descuento =((new Decimal(values.cotd_cantidad).times(new Decimal(values.cotd_precio))).toDecimalPlaces(2,Decimal.ROUND_UP).times(new Decimal(values.cotd_descuento_number===""?0:values.cotd_descuento_number)/100)).toDecimalPlaces(2,Decimal.ROUND_DOWN);
    var itbms =((new Decimal(values.cotd_cantidad).times(new Decimal(values.cotd_precio))).minus(descuento)).times(new Decimal(row.original.art_itbm_venta)).toDecimalPlaces(2,Decimal.ROUND_UP);

    if(basicModalEdit){
      update_cotd_cotizacion_detalle_row({
        cotd_art_descripcion:values.art_descripcion,
        cotd_precio:values.cotd_precio,
        cotd_cantidad:values.cotd_cantidad,
        cotd_id:row.original.cotd_id, 
        cotd_itbms:itbms,
        cotd_descuento :descuento,
        cotd_descuento_number : values.cotd_descuento_number===""?0:values.cotd_descuento_number,
        cotd_total: subtotal.minus(new Decimal(descuento)).plus(new Decimal(itbms)).toDecimalPlaces(2,Decimal.ROUND_UP), 
      },row.original.cotd_identificador)
    }
    OBJCotizacionDetalle[row.index] = {
      art_descripcion: values.art_descripcion,
      art_itbm_cod_v:row.original.art_itbm_cod_v,
      art_itbm_venta:row.original.art_itbm_venta,
      art_upc: row.original.art_upc,
      cotd_articulo: row.original.cotd_articulo,
      cotd_cantidad: values.cotd_cantidad,
      cotd_descuento :descuento,
      cotd_descuento_number : values.cotd_descuento_number===""?0:values.cotd_descuento_number,
      cotd_itbms: itbms,
      cotd_precio: values.cotd_precio,
      cotd_total: subtotal.minus(new Decimal(descuento)).plus(new Decimal(itbms)).toDecimalPlaces(2,Decimal.ROUND_UP), 
    };
    setOBJCotizacionDetalle([...OBJCotizacionDetalle]);
    exitEditingMode();
  };

  const handleSaveRowCliente = ({exitEditingMode,row,values}) => {
    onClickUpdateClient({
      cli_id:row.original.cli_id, 
      cli_nombre:values.cli_nombre, 
      cli_direccion:row.original.cli_direccion,
      cli_telefono2:row.original.cli_telefono2,
      cli_ruc:values.cli_ruc.trim(), 
      cli_dv:values.cli_dv, 
      cli_telefono:values.cli_telefono, 
      cli_email: values.cli_email,
      cli_retencion:values.re_id
    })
    exitEditingMode();
  };

  OBJCotizacionDetalle.map((row,i)=>{
    subtotal = (new Decimal(row.cotd_total).minus(new Decimal(row.cotd_itbms))).plus(subtotal) 
    itbms = new Decimal(row.cotd_itbms).plus(itbms);
    total =   new Decimal(row.cotd_total).plus(total);
    return null;
  });

    subtotal = subtotal.toDecimalPlaces(2,Decimal.ROUND_UP);
    total = total.toDecimalPlaces(2,Decimal.ROUND_UP);
    itbms = itbms.toDecimalPlaces(2,Decimal.ROUND_UP);
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog  size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":"modal-full-large"}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{formCotCotizacion.cot_id!==""?"Cotización #"+formCotCotizacion.cot_id.length:"Nueva cotización"}</MDBModalTitle>
                {/* {isTabClientes || isTabItems?"":<MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);fetch_cot_cotizacion()}}></MDBBtn>} */}
            </MDBModalHeader>
            <MDBModalBody className="pdd-1">
              {isTabClientes?<>
                <Row>
                  <Col xs={12} className="mb-2 datatable-factura">
                    {dataCliente !==undefined?<DATATABLE_LISTA_CLIENTE dataCliente ={dataCliente} 
                    selectCliente ={selectCliente} setTabClientes ={setTabClientes} handleSaveRow={handleSaveRowCliente}/>:<Label>Cargando...</Label>}
                  </Col>
                </Row>
              </>: isTabAddClientes?<>
                  <Col xs={12}>
                    <Label>Nuevo cliente</Label>
                  </Col>
                  <Col xs={12}>
                    <form>
                      <Row>
                        <Col xs={12}  sm={4} className="input-tablet">
                          <MDBInput
                            id="cli_nombre"
                            wrapperClass="mb-2"
                            label="* Nombre"
                            name="cli_nombre"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_nombre}/>
                        </Col>
                        <Col xs={12}  sm={4} className="input-tablet">
                          <MDBInput
                            id="cli_direccion"
                            wrapperClass="mb-2"
                            label="Dirección"
                            name="cli_direccion"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_direccion}/>
                        </Col>
                        <Col  xs={12}  sm={4} className="input-tablet">
                          <MDBInput
                            type="email"
                            id="cli_email"
                            wrapperClass="mb-2"
                            label="E-MAIL"
                            name="cli_email"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_email}/>
                        </Col>
                        <Col xs={6}  sm={4} className="input-tablet">
                          <MDBInput
                            type="text"
                            id="cli_telefono"
                            wrapperClass="mb-2"
                            label="Teléfono"
                            name="cli_telefono"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_telefono}/>
                        </Col>
                        <Col xs={6}  sm={4} className="input-tablet">
                          <MDBInput
                            id="cli_telefono2"
                            wrapperClass="mb-2"
                            label="Teléfono 2"
                            name="cli_telefono2"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_telefono2}/>
                        </Col>
                        <Col xs={8}  sm={4} className="input-tablet">
                          <MDBInput
                            type="text"
                            id="cli_ruc"
                            wrapperClass="mb-2"
                            label="RUC"
                            name="cli_ruc"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_ruc}/>
                        </Col>
                        <Col xs={4}  sm={4} className="input-tablet">
                          <MDBInput
                            type="number"
                            min={1}
                            max={99}
                            id="cli_dv"
                            wrapperClass="mb-2"
                            label="DV"
                            name="cli_dv"
                            onChange={onChangeCliente}
                            defaultValue={formClientes.cli_dv}/>
                        </Col>
                        <Col xs={6} className="mt-2 d-flex input-tablet">
                          <MDBBtn 
                            className="btn-waranty d-flex"
                            id="basic-button"
                            aria-controls={openRe ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openRe ? 'true' : undefined}
                            onClick={handleClickRetencion}
                            disabled ={false}>
                            <Row className="mx-auto">
                              <Col xs={12} className="text-center d-flex">
                                <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                                Retención
                              </Col>
                            </Row>
                          </MDBBtn>
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorElRe}
                              open={openRe}
                              onClose={handleCloseRetencion}
                              MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                 "className":' css-retencion'}}>
                                { dataRetencion.map((data,i)=>{
                                  return <>
                                    <MenuItem onClick={()=>{handleCloseRetencion();setFormClientes({...formClientes,re_id:data.re_id,re_desc:data.re_desc, re_porc:data.re_porc,re_codigo:data.re_codigo})}}>{data.re_desc}</MenuItem>
                                  </>
                                })}
                      
                            </Menu>
                              <img src={EXIT_IMAGE} className="src-image-w2" alt="..."  onClick={()=>{      setFormClientes({...formClientes,re_desc:"", re_porc:"", re_codigo:"",	})}}/>
                          </Col>
                          <Col xs={6} className="input-tablet mt-2">
                            <MDBInput
                              type="cli_limitc"
                              id="cli_limitc"
                              wrapperClass="mb-2"
                              label="Límite de crédito"
                              name="cli_limitc"
                              onChange={onChangeCliente}
                              defaultValue={formClientes.cli_limitc}
                            />
                          </Col>
                            {formClientes.re_desc.length>1?<Col xs={12}>
                            <Label className="padd-mar-u">{"Retención :" +formClientes.re_desc}</Label></Col>:""   }
                        </Row>
                        <div className="form-check form-check-inline mt-1">
                          <input className="form-check-input" type="checkbox" name="cli_credito" id="inlineRadioPrecio" onChange={handleOnChangeCheckBox}  value={formClientes.cli_credito} checked={formClientes.cli_credito==="1"?true:false}/>
                          <label className="form-check-label" htmlFor="inlineRadioPrecio">Habiliar limite de crédito</label>
                        </div>
                      </form>
                      <Row>
                        <Col xs={12} className="text-end">
                          <Label className="error-label">{error.length > 0 ? error : ""}</Label>
                        </Col>
                      </Row>
                  </Col>
                
                
                
                
                </>:<>
                <>
                  {isTabItems?<>
                   {isOpenDetailItem?<> {ITEM_DETAIL_PANEL({SetOpenDetailItem,formDetailItem,existencia})}</>:
                  <><Row>
                      <Col xs={12} className="datatable-factura datatable-factura  css_datatable1">
                        {dataItems !==undefined?<DATATABLE_LISTA_ITEMS select_detail_articulo ={select_detail_articulo} dataItems ={dataItems} selectItem ={selectItem} setTabItems={setTabItems}/>:<Label>Cargando...</Label>}
                      </Col>
                    </Row></>}

                </>:<>{isTabImageView?<>
                <Col xs={12} className="text-center mt-2">
                <Row>
                  <Col xs={12} sm={6} className="input-tablet">
                  <MDBTextArea  
                              id="art_img"
                              wrapperClass="mb-2"
                              label="Descripción"
                              name="art_img"
                              onChange={onChange}
                              type="textarea"
                              rows="3"
                              defaultValue={formImg.img_name}
                               disabled={true}>
                            </MDBTextArea>
  
                  </Col>
                   <Col  xs={6} sm={3} className="input-tablet">
                      <MDBInput
                        id="art_upc"
                        type="text"
                        wrapperClass="mb-2"
                        label="Código"
                        name="art_upc"
                        defaultValue={formImg.art_upc}
                        disabled={true}/>
                  </Col>
                  <Col  xs={6} sm={3} className="input-tablet">
                      <MDBInput
                        id="art_referencia"
                        type="text"
                        wrapperClass="mb-2"
                        label="Referencia"
                        name="art_referencia"
                        defaultValue={formImg.art_referencia}
                        disabled={true}/>
                  </Col>
                  <Col xs={4} sm={4} className="input-tablet">
                      <MDBInput
                        id="cotd_itbms"
                        type="text"
                        wrapperClass="mb-2"
                        label="ITBMS"
                        name="cotd_itbms"
                        defaultValue={Number(formImg.cotd_itbms).toFixed(2)}
                        disabled={true}/>
                  </Col>
                  <Col xs={4} sm={4} className="input-tablet">
                      <MDBInput
                        id="cotd_descuento"
                        type="text"
                        wrapperClass="mb-2"
                        label="Descuento"
                        name="cotd_descuento"
                        defaultValue={formImg.cotd_descuento}
                        disabled={true}/>
                  </Col>
                  <Col xs={4} sm={4} className="input-tablet">
                      <MDBInput
                        id="cotd_cantidad"
                        type="text"
                        wrapperClass="mb-2"
                        label="Cantidad"
                        name="cotd_cantidad"
                        defaultValue={formImg.cotd_cantidad}
                        disabled={true}/>
                  </Col>
                </Row>
                  </Col><Col xs={12}>
                   <img src={formImg.imgUrl} className="w-art-cot" alt="..."/>
                  </Col></>:<>
                <form>


                        <Row>
                          <Col xs={8}  md={3} className="d-flex input-tablet">
                            <MDBInput
                                id="cli_nombre"
                                type="text"
                                wrapperClass="mb-2"
                                name="cli_nombre"
                                defaultValue={formClientes.cli_nombre.length>0?formClientes.cli_nombre+" "+formClientes.cli_ruc:"Cliente"}
                                disabled={true}
                              />
                              <img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabClientes(true)}}/>
                              <img src={ADD_IMAGE} className="src-image ml-1" alt="..." onClick={()=>{setTabAddClientes(true);setFormClientes(STATES_COT_COTIZACION({staneName:"formClientes"}))}}/>
                          </Col>
                          <Col xs={4}  md={2} className="input-tablet">
                            <MDBInput
                              id="dc_fecha"
                              type="date"
                              wrapperClass="mb-2"
                              name="cot_fecha"
                              onChange={onChange}
                              defaultValue={formCotizacion.cot_fecha}/>
                          </Col>
                          <Col xs={4} sm={2}  className="text-right input-tablet">
                            {dataGarantia.length>1?<>                  
                              <MDBBtn 
                                className="btn-waranty d-flex btn-garantia"
                                id="basic-button"
                                aria-controls={openGR ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openGR ? 'true' : undefined}
                                onClick={handleClickGarantia}
                                disabled ={false}
                                >
                                <img src={AWARD} className="pagar-garantia-btn" alt="..."/>
                                  Garantía
                              </MDBBtn>
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorElGr}
                                open={openGR}
                                onClose={handleCloseGarantia}
                                MenuListProps={{
                                  'aria-labelledby': 'basic-button',
                                }}>
                                  { dataGarantia.map((data,i)=>{
                                    return <><MenuItem onClick={()=>{setFormCotCotizacion({...formCotCotizacion,cot_garantia:formCotCotizacion.cot_garantia+"\n"+data.gr_descripcion,cot_garantia_name:formCotCotizacion.cot_garantia_name+" \n"+data.gr_name}); handleCloseGarantia()}}>{data.gr_name}</MenuItem>
                                    </>
                                  })}
                              </Menu></>:""}
                          </Col>
                          <Col xs={8} sm={2}  className="waranty-div d-flex input-tablet">
                            {formCotCotizacion.cot_garantia_name.length>0?<><Label className="error-label-waranty padd-mar-u">{formCotCotizacion.cot_garantia_name}</Label><img src={EXIT_IMAGE} className="src-image-w" alt="..." onClick={()=>{      setFormCotCotizacion({...formCotCotizacion,cot_garantia:"",cot_garantia_name:""})}}/></>:null}
                          </Col>
                          {window.innerWidth<=611?<Col xs={12} sm={12}  className="input-tablet mt-2">
                            <MDBTextArea  
                              id="cot_descripcion"
                              wrapperClass="mb-2"
                              label="Descripción"
                              name="cot_descripcion"
                              onChange={onChange}
                              type="textarea"
                              rows="1"
                              defaultValue={formCotizacion.cot_descripcion}>
                            </MDBTextArea>
                          </Col>:null}

                          {window.innerWidth<=611?null:<Col xs={3} sm={3}   className="input-tablet">
                            <MDBTextArea  
                              id="cot_descripcion"
                              wrapperClass="mb-2"
                              label="Descripción"
                              name="cot_descripcion"
                              onChange={onChange}
                              type="textarea"
                              rows="2"
                              defaultValue={formCotizacion.cot_descripcion}>
                            </MDBTextArea>
                          </Col>}
                        </Row>
                      </form>
                      <Row>
                        <Col xs={12} sm={12} className="input-tablet">
                          <Label className="error-label-inventario padd-mar-u">- {error_upc}</Label>
                        </Col>
                  
                      <Col xs={8} sm={2} className="d-flex input-tablet">
                        <MDBInput
                          id="art_upc"
                          wrapperClass="mb-2"
                          label="Código o referencia"
                          name="art_upc"
                          onChange={onChangeCot_detail}
                          value={formCotCotizacionDetalle.art_upc}
                          disabled={enableTab}
                          onKeyDown={(e) =>{
                            handleKeyPress(e, formCotCotizacionDetalle.art_upc);
                          }
                          }
                        />
                        {formClientes.cli_nombre.length>0?<img src={SEARCH_IMAGE} className="src-image" alt="..." onClick={()=>{setTabItems(true);SetOpenDetailItem(false)}}/>:null}
                      </Col>
                      <Col  xs={4} sm={2} className="input-tablet">
                      <MDBInput
                      disabled={true}
                          id="art_referencia"
                          wrapperClass="mb-2"
                          label="Referencia"
                          name="art_referencia"
                          onChange={onChangeCot_detail}
                          value={formCotCotizacionDetalle.art_referencia}
                        />
                      </Col>
                      <Col xs={12} sm={4} className="input-tablet">
                      <MDBInput
                          id="art_descripcion"
                          wrapperClass="mb-2"
                          label="Descripción del artículo"
                          name="art_descripcion"
                          onChange={onChangeCot_detail}
                          value={formCotCotizacionDetalle.art_descripcion}
                          disabled ={formCotCotizacionDetalle.art_upc.length>0 && usr_precio==="1"?false:true}
                        />
                      </Col>
                      <Col xs={6} sm={2} className="d-flex input-tablet">
                      <MDBInput
                          id="cotd_precio"
                          wrapperClass="mb-2"
                          label="Precio"
                          name="cotd_precio"
                          type={"number"}
                          min={"1"}
                          autoFocus ={true}
                          value={formCotCotizacionDetalle.cotd_precio}
                          disabled ={formCotCotizacionDetalle.art_upc.length>0 && usr_precio==="1"?false:true}
                          onChange={onChangeCot_detail}
                        />
                          <Button
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                            disabled ={formCotCotizacionDetalle.art_upc.length>0  ?false:true}
                          >
                          <img src={PRECIO_IMAGE} className="src-image style-precio-btn" alt="..."/>
                          </Button>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                              'aria-labelledby': 'basic-button',
                            }}
                          >
                            <MenuItem onClick={()=>{setPrecio(formPrecio.art_precio);    setAnchorEl(false)}}>{formPrecio.art_precio}</MenuItem>
                            <MenuItem onClick={()=>{setPrecio(formPrecio.art_precio2);    setAnchorEl(false)}}>{formPrecio.art_precio2}</MenuItem>
                            <MenuItem onClick={()=>{setPrecio(formPrecio.art_precio3);    setAnchorEl(false)}}>{formPrecio.art_precio3}</MenuItem>
                          </Menu>
                      </Col>
                      <Col xs={6} sm={2} className="d-flex input-tablet">
                      <MDBInput
                          id="cotd_cantidad"
                          wrapperClass="mb-2"
                          label="Cantidad"
                          name="cotd_cantidad"
                          type={"number"}
                          min={"1"}
                          ref={inputCantidad}
                          disabled ={formCotCotizacionDetalle.art_upc.length>0  ?false:true}
                          onChange={onChangeCot_detail}
                          value={formCotCotizacionDetalle.cotd_cantidad}
                          onKeyDown={(e) =>
                            handleKeyPress(e, formCotCotizacionDetalle.cotd_cantidad)
                          }
                        />
                         {formCotCotizacionDetalle.cotd_cantidad !==""?<img src={ADD_IMAGE}  name="cotd_cantidad" className="src-image" alt="..." onClick={(e)=>{handleKeyPress(e, formCotCotizacionDetalle.cotd_cantidad);}}/>:<img src={ADD_IMAGE} className="src-image-2" alt="..." />}
                      </Col>
                      <Col xs={12} className="modal-add-inventario datatable-factura">
                        <DATATABLE_COTIZACION_DETALLE enableTab={enableTab} selectItem ={selectItem} deleteRow={deleteRow} OBJCotizacionDetalle ={OBJCotizacionDetalle}
                        handleSaveRow={handleSaveRow} usr_precio={usr_precio} viewImage={viewImage}/>
                      </Col>
                    </Row>
                              {isTabClientes ===false && isTabAddClientes === false && isTabItems===false ?<>              <Row className="mt-3">
                <FOOTER_FACTURA enableTab = {enableTab} subtotal = {subtotal} itbms = {itbms} total ={total}/>
                </Row></>:null}
                
                </>}
                      
              </>}
              </>
              </>
              }


            </MDBModalBody>
            <MDBModalFooter>


              {isTabAddClientes?<MDBBtn color="danger"  className={"d-flex"} onClick={() => {setTabAddClientes(false);setFormClientesBlank(); setError("")}}>
                <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />    Cerrar
              </MDBBtn>:null}
              {isTabImageView?<MDBBtn color="danger"  className={"d-flex"} onClick={() => setTabImgView(false)}>
                <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />    Cerrar
              </MDBBtn>:null}
              {isTabItems?<MDBBtn color="danger"  className={"d-flex"} onClick={() => setTabItems(false)}>
                <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />    Cerrar
              </MDBBtn>:null}
                        {isTabClientes?<MDBBtn color="danger"  className={"d-flex"} onClick={() => setTabClientes(false)}>
                <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />    Cerrar
              </MDBBtn>:null}
               {isTabClientes === false && isTabItems ===false && isTabImageView ===false  && isTabAddClientes === false?<MDBBtn color="danger"  className={"d-flex"} onClick={() => {toggle(false);fetch_cot_cotizacion()}}>
                <MDBIcon fas icon="ban" className="me-1 class-btn-factura d-flex"  />    Cerrar
              </MDBBtn>:null}
              {isTabAddClientes?<MDBBtn  className={"d-flex"} onClick={() => {onClickSaveCliente()}}>
                <MDBIcon fas icon="save" className="me-1 class-btn-factura d-flex"  />    Guardar
              </MDBBtn>:null}
                {isTabClientes ===false && isTabAddClientes === false && isTabItems===false && isTabImageView ===false  && isTabAddClientes === false?<>{basicModalEdit?<MDBBtn className="d-flex"  onClick={() => ( toggleSaveEncabezado(),toggle(false),fetch_cot_cotizacion())} disabled={loading}>
                  <MDBIcon fas icon="save" className="me-1 class-btn-factura d-flex"  /> Guardar
                </MDBBtn>:    <MDBBtn className="d-flex" onClick={() => ( toggleSave())} disabled={OBJCotizacionDetalle[0]!==undefined &&loading===false?false:true}>
                <MDBIcon  fas icon="save" className="me-1 class-btn-factura d-flex"  />   Guardar
              </MDBBtn>}</>:<></>}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const EnviadoCocinaModal = ({
  isOpen,
  toggle
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Enviando a la cocina..</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
            <img src={SUCCES_IMAGE} className="src-image-enviado" alt="..."/>
            <Row>
              <Col xs={12}>
              </Col>
            </Row>
            </MDBModalBody>
    
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const EnviadoModal = ({
  isOpen,
  toggle,
  dataListpago,
  total
}) => {
  var monto =0;
  dataListpago.map((data,i)=>{
    monto = monto + Number(data.list_monto)
    return null
  });
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Factura creada</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
            <img src={SUCCES_IMAGE} className="src-image-enviado" alt="..."/>
            <Row>
              <Col xs={3}>
              </Col>
              <Col xs={6} className="mt-3">
                    <MDBInput
                      className="input-iventario-totales2"
                      id="total"
                      wrapperClass="mb-4"
                      label="TOTAL"
                      name="total"
                      autoFocus={true}
                      value={new Decimal(total).toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                 </Col>
                <Col xs={3}>
                </Col>
                  <Col xs={6}>
                    <MDBInput
                      className="input-iventario-totales2"
                      id="recibido"
                      wrapperClass="mb-4"
                      label="RECIBIDO"
                      name="recibido"
                      autoFocus={true}
                      value={monto.toFixed(2)}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={3}>
                  </Col>
                  <Col xs={3}>
                  </Col>
                  <Col xs={6}>
                    <MDBInput
                      className="input-iventario-totales2"
                      id="vuelto"
                      wrapperClass="mb-4"
                      label="VUELTO"
                      name="vuelto"
                      autoFocus={true}
                      value={(monto- total).toFixed(2)}
                      disabled={true}
                    />
              </Col>
              <Col xs={3}>

              </Col>
            </Row>
            </MDBModalBody>
    
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ImageTooltipModalPublicidad = ({
  isOpen,
  toggle,
  srcImage
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   onClose={toggle}>
        <MDBModalDialog onClose={toggle} >
          <MDBModalContent>
            <MDBModalHeader>
                <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
              <img src={srcImage} className="src-image-articulo-tooltip" alt="..."/>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const ImageTooltipModal = ({
  props,
  isOpen,
  toggle,
  srcImage,
  ImgName
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1"   onClose={toggle}>
        <MDBModalDialog onClose={toggle} >
          <MDBModalContent>
            <MDBModalHeader>
              <Row>
                <Col xs={12}>
                  <Label>{props.art_descripcion + " (" +ImgName+")"}</Label>
                </Col>
                <Col xs={12}>
                  <MDBModalTitle className="font-weight-bold">{"PRECIO " +props.art_precio}</MDBModalTitle>
                </Col>
                <Col xs={12}>
                  <MDBModalTitle className="font-weight-bold">{"EXISTENCIA " +props.inv_qty}</MDBModalTitle>
                </Col>
              </Row>
            </MDBModalHeader>
            <MDBModalBody className="text-center">
              <img src={srcImage} className="src-image-articulo-tooltip" alt="..."/>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};
const RucModal = ({formRuc,isOpen,toggle,onChange,setFormRuc,onClickBuscarRuc,errorRuc,dataRuc}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className={window.innerWidth<=611?"modal-fiscal":""}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Consultar RUC</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                <React.Fragment>
                  {window.innerWidth<=611?<>
                  <Col xs={5} className="input-tablet">
                  <MDBInput
                  className="input-buscar-ruc"
                  id="ruc"
                  wrapperClass="mb-3"
                  label="RUC"
                  name="ruc"
                   onChange={onChange}
                  value={formRuc.ruc}
                  />
                  </Col>
                <Col xs={3} className="input-tablet">
                  <MDBInput
                  className="input-buscar-ruc"
                  id="dv"
                  wrapperClass="mb-3"
                  label="DV"
                  name="dv"
                  onChange={onChange}
                  value={formRuc.dv}
                  />
                  </Col>
                  <Col xs={4} className="input-tablet">
                  <MDBBtn onClick={() =>  onClickBuscarRuc()} disabled={formRuc.ruc.length>0?false:true}>
                    Buscar
                </MDBBtn>
                  </Col>
                  {dataRuc.codigo.length>0?<><Col xs={3} className="input-tablet">
                  <MDBInput
                  id="codigo"
                  wrapperClass="mb-3"
                  label="Código"
                  name="codigo"
                  value={dataRuc.codigo}
                  />
                  </Col>
                  <Col xs={9} className="input-tablet">
                  <MDBInput
                  id="afiliadoFE"
                  wrapperClass="mb-3"
                  label="Afiliado FE"
                  name="afiliadoFE"
                  value={dataRuc.afiliadoFE}
                  />
                  </Col>
                  <Col xs={12} className="input-tablet">
                  <MDBInput
                 
                  id="razonSocial"
                  wrapperClass="mb-3"
                  label="Razón social"
                  name="razonSocial"
                  value={dataRuc.razonSocial}
                  />
                  </Col>
                  <Col xs={9} className="input-tablet">
                  <MDBInput
                 
                  id="ruc"
                  wrapperClass="mb-3"
                  label="RUC"
                  name="tuc"
                  value={dataRuc.ruc}
                  />
                  </Col>
                  <Col xs={3} className="input-tablet">
                  <MDBInput
                 
                  id="dv"
                  wrapperClass="mb-3"
                  label="DV"
                  name="dv"
                  value={dataRuc.dv}
                  />
                  </Col>
                  <Col xs={12} className="input-tablet">
                  <MDBInput
                
                  id="mensaje"
                  wrapperClass="mb-3"
                  label="Mensaje"
                  name="mensaje"
                  value={dataRuc.mensaje}
                  />
                  </Col>
                                    <Col xs={12} className="input-tablet">
                  <MDBInput
                
                  id="tipoRuc"
                  wrapperClass="mb-3"
                  label="Tipo ruc"
                  name="tipoRuc"
                  value={dataRuc.tipoRuc==="1"?"Natural":dataRuc.tipoRuc===""?"":"Jurídico"}
                  />
                  </Col></>:<></>}
                  
                  </>:<>
                  
                                  <Col xs={4} >
                  <MDBInput
                  className="input-buscar-ruc"
                  id="ruc"
                  wrapperClass="mb-3"
                  label="RUC"
                  name="ruc"
                   onChange={onChange}
                  value={formRuc.ruc}
                  />
                  </Col>
                <Col xs={1}>
                  <MDBInput
                  className="input-buscar-ruc"
                  id="dv"
                  wrapperClass="mb-3"
                  label="DV"
                  name="dv"
                  onChange={onChange}
                  value={formRuc.dv}
                  />
                  </Col>
                  <Col xs={7}>
                  <MDBBtn onClick={() =>  onClickBuscarRuc()} disabled={formRuc.ruc.length>0?false:true}>
                    Buscar
                </MDBBtn>
                  </Col>
                  {dataRuc.codigo.length>0?<><Col xs={1}>
                  <MDBInput
                  id="codigo"
                  wrapperClass="mb-4"
                  label="Código"
                  name="codigo"
                  value={dataRuc.codigo}
                  />
                  </Col>
                  <Col xs={3}>
                  <MDBInput
                  id="afiliadoFE"
                  wrapperClass="mb-4"
                  label="Afiliado FE"
                  name="afiliadoFE"
                  value={dataRuc.afiliadoFE}
                  />
                  </Col>
                  <Col xs={4}>
                  <MDBInput
                 
                  id="razonSocial"
                  wrapperClass="mb-4"
                  label="Razón social"
                  name="razonSocial"
                  value={dataRuc.razonSocial}
                  />
                  </Col>
                  <Col xs={3}>
                  <MDBInput
                 
                  id="ruc"
                  wrapperClass="mb-4"
                  label="RUC"
                  name="tuc"
                  value={dataRuc.ruc}
                  />
                  </Col>
                  <Col xs={1}>
                  <MDBInput
                 
                  id="dv"
                  wrapperClass="mb-4"
                  label="DV"
                  name="dv"
                  value={dataRuc.dv}
                  />
                  </Col>
                  <Col xs={9}>
                  <MDBInput
                
                  id="mensaje"
                  wrapperClass="mb-4"
                  label="Mensaje"
                  name="mensaje"
                  value={dataRuc.mensaje}
                  />
                  </Col>
                                    <Col xs={3}>
                  <MDBInput
                
                  id="tipoRuc"
                  wrapperClass="mb-4"
                  label="Tipo ruc"
                  name="tipoRuc"
                  value={dataRuc.tipoRuc==="1"?"Natural":dataRuc.tipoRuc===""?"":"Jurídico"}
                  />
                  </Col></>:<></>}
                    
                  
                  </>}

                  
                </React.Fragment>
            </Row>
            </MDBModalBody>
            <MDBModalFooter>
                  <Label className="error-label">{errorRuc.length > 0 ? errorRuc : ""}</Label>

                <MDBBtn  onClick={() => toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
                
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const AnulacionModal = ({
  dataListAnulacion,
  isOpen,
  toggle,
  formAnulacion,
  onChange,
  setFormAnulacion,
  toggleSave,
  usr_print,
  errorAnulacion
}) => {
  const [istabAnular, setTabAnular] = useState(true);
  const [istabNC, setTabAnularNC] = useState(false);
  const [isOpenDetailCopia, SetOpenDetailCopia] = useState(false);
  const [dataCopiaFactura, setDataCopiaFactura] = useState([]);
  const [fac_selected, setfacSelected] = useState("");

  async function getDetailItem({data}) {
    setfacSelected(data.fac_id)
    var response = await get_list_itemsFactura_detail(data.fac_identificador);
    setDataCopiaFactura({
      factura:response.factura,
      fPago:response.fPago
    });
  }

  var flag_qty_caracteres = false;
  if(formAnulacion.motivo_anulacion.length>=10){
    flag_qty_caracteres = true;
  }
  const deleteRow = (row) => {
    var value = dataCopiaFactura.factura.filter((data, i) => {
      if (i !== row.index) return data;
    });
    setDataCopiaFactura(value);
        setDataCopiaFactura({...dataCopiaFactura,
      factura:value
    });
    // setdataFacturaDetallePr({dataFacturaDetallePr:{
    //   dataFacturaDetalle:value,formClientes,dataListPago
    // }})
  };
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog size={window.innerWidth<=611?"fullscreen":"xl"} className="modal-fiscal">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Anular factura</MDBModalTitle>
              {/* <MDBBtn className="btn-close" color="none" onClick={() => toggle(false)}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody>
              <Row>
                {istabAnular? <Col xs={12} className="datatable-factura  css_datatable1">
                <DATATABLE_COLUMNS_LISTA_ANULACION dataListAnulacion ={dataListAnulacion} setTabAnular={setTabAnular} setTabAnularNC={setTabAnularNC} setFormAnulacion ={setFormAnulacion} getDetailItem={getDetailItem}/>
                </Col>:
                istabNC?<>
                  {dataCopiaFactura.factura !==undefined&&PANEL_VIEW_INVOICE({fac_selected,dataCopiaFactura,nc_flag:true,deleteRow})}
                
                </>:
                <React.Fragment>
                  <Col xs={12} sm={4}>
                    <MDBInput
                    className="input-iventario-totales"
                    id="docNumber"
                    wrapperClass="mb-4"
                    label="# de factura"
                    name="docNumber"
                    autoFocus={true}
                    value={formAnulacion.fac_id.toString().padStart(10, "0")}/>
                  </Col>
                  <Col xs={12} sm={8}>
                    <MDBTextArea 
                      className="input-iventario-totales"
                      id="motivo_anulacion"
                      wrapperClass="mb-4"
                      // minlength ={40}
                      label="* Descripción de la anulación"
                      name="motivo_anulacion"
                      autoFocus={true}
                      onChange={onChange}
                      value={formAnulacion.motivo_anulacion}
                      rows={2}/>
                  </Col>
                </React.Fragment>
}
              </Row>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn  onClick={() => !istabAnular?setTabAnular(true):toggle(false)} color="danger">
                    Cerrar
                </MDBBtn>
              {(!istabAnular && !istabNC)&&<><Label className="error-label">{errorAnulacion.length > 0 ? errorAnulacion : ""}</Label>
              {((usr_print ==="1"||usr_print ==="4") && formAnulacion.fac_recibo==="1")&&<MDBBtn onClick={() =>  toggleSave({tipo:formAnulacion.fac_recibo,print_mode:"1"})} disabled={flag_qty_caracteres>0?false:true}>
                  Anular PDF
              </MDBBtn>}
              {(usr_print ==="2"||usr_print ==="4" || formAnulacion.fac_recibo==="0")&&<MDBBtn onClick={() =>  toggleSave({tipo:formAnulacion.fac_recibo,print_mode:"2"})} disabled={flag_qty_caracteres>0?false:true}>
                  Anular Recibo
              </MDBBtn>}</>}
              {/* {istabNC&&<><Label className="error-label">{errorAnulacion.length > 0 ? errorAnulacion : ""}</Label>
              {((usr_print ==="1"||usr_print ==="4") && formAnulacion.fac_recibo==="1")&&<MDBBtn onClick={() =>  toggleSave({tipo:formAnulacion.fac_recibo,print_mode:"1"})} disabled={flag_qty_caracteres>0?false:true}>
                  NC PDF
              </MDBBtn>}
              {(usr_print ==="2"||usr_print ==="4" || formAnulacion.fac_recibo==="0")&&<MDBBtn onClick={() =>  toggleSave({tipo:formAnulacion.fac_recibo,print_mode:"2"})}>
                  NC Recibo
              </MDBBtn>}</>} */}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

const DateRangeModal = ({
  isOpen,
  toggle,
  show_year_month,
  open,
  handleOnChangeDate,
  state
}) => {
  return (
    <React.Fragment>
      <MDBModal show={isOpen} setShow={toggle} tabIndex="-1" staticBackdrop>
        <MDBModalDialog >
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Calendario</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => {toggle(false);}}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
            <Row>
              <Col xs={12} className={"text-center"} >
              {show_year_month?<><Calendar 
                    onChange={handleOnChangeDate}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    editableDateInputs={true}
                    dateDisplayFormat="yyyy-MM-dd-"
                    ranges={state}
                    direction="horizontal"
                    className="box-calendar"
                  /></>:<>                {open && (
                  <DateRange 
                    onChange={handleOnChangeDate}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    editableDateInputs={true}
                    dateDisplayFormat="yyyy-MM-dd-"
                    ranges={state}
                    direction="horizontal"
                    className="box-calendar"
                  />
                )}</>}

              </Col>
            </Row>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </React.Fragment>
  );
};

export {
  ListaCajas,
  PublicidadModal,
  DescuentoModal,
  GarantiaModal,
  EnviadoCocinaModal,
  DateRangeModal,
  EnviadoModal,
  PagarModal,
  DeleteModal,
  UsuariosModal,
  BodegaModal,
  ClienteModal,
  ProveedorModal,
  CategoriaModal,
  MarcaModal,
  ArticuloModal,
  FacturaCompraModal,
  ListaClienteModal,
  ListaItemModal,
  ListaFacModal,
  CotizacionModal,
  AnulacionModal,
  ApartadoModal,
  RecuentoModal,
  MovimientoModal,
  ListaCotizacion,
  ListaOrden,
  ImageTooltipModal,
  ListaCreditos,
  ImageTooltipModalPublicidad,
  WarningModal,
  RucModal,
  GastosModal,
  ModalReporteZ
};
